import { nanoid } from "nanoid";
import React, { Component } from "react";
import ViewSwitcher from "../../../components/ViewSwitcher";
import ItemModal from "../../../modals/ItemModal";
import HttpServices from "../../../utils/Http.services";
import { checkPermission, checkTranslation, checkVariablesListForValue, getObject, translate } from "../../../utils/useful";
import * as actions from '../../../stores/actionsList';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import SocketServices from "../../../utils/socket.services";
import SidebarView from "../../../components/SidebarView";
import FieldsData from "../../../components/FieldsData";
import { FormBuilderObjects } from "../../../variables/formBuilderData"
import ButtonAnimated from "../../../components/buttons/ButtonAnimated";
import RemoveConfirmationModal from "../../../modals/RemoveConfirmationModal";
import AddFieldsList from "../../../components/AddFieldsList";
import StackedField from "../../../components/inputs/StackedField";
import FilterEditorModal from "../../../components/inputs/FilterEditorModal";
import CustomizeFields from '../../../components/inputs/CustomizeFields';
import SortedBy from '../../../components/inputs/SortedBy';
import GroupedBy from '../../../components/inputs/GroupedBy';
import PrintModal from "../../../components/modals/PrintModal";
import ImportModal from "../../../components/modals/ImportModal";
import ExportModal from "../../../components/modals/ExportModal";
import CollectionToolbar from "../../../components/header/CollectionToolbar";
import ActivityLogs from "../../../components/ActivityLogs";
import AddViewList from "../../../components/AddViewList";
import CustomizeCard from "../../../components/inputs/CustomizeCard";
import { checkRigram } from "../../../utils/diagram";
import AddUserModal from "../../../modals/AddUserModal";
import FormViewer from "../../../components/FormViewer";
import importedIcons from "../../../components/inputs/icons";
import AddUserSidebar from "../../../modals/AddUserSidebar";
import RecordViewerModal from "../../../modals/RecordViewerModal";
import Pagination from "../../../components/Pagination";
import RemoveHeaderModal from "../../../modals/RemoveHeaderModal";
import HideHeaderModal from "../../../modals/HideHeaderModal";
import EditFields from "../../../components/EditFields";
// import SideActionsList from "../../../components/SideActionsList";
import NewInquiry from "../inquiries/NewInquiry";
import SingleRecordView from "../../../components/SingleRecordView";
import HistoryViewer from "../../../components/HistoryViewer";
import LookupAddNewModal from "../../../modals/LookupAddNewModal";
import FramePermissionsModal from "../../../modals/FramePermissionsModal";
import ActionsConfigModal from "../../../modals/ActionsConfigModal";
import FrameAutomationsModal from "../../../modals/FrameAutomationsModal";
import MemoModal from "../../../components/modals/MemoModal";

import PrintLabelModal from "../../../components/inputs/PrintLabelModal";
import PageViewerInstant from "../../PageViewerInstant";
import { framesConfig } from "../../../variables/framesStatics";
import RelatedFrames from "../../../components/inputs/RelatedFrames";
import FrameSynchronizations from "../../../components/inputs/FrameSynchronizations";

class CollectionView extends Component {

    state = {
        checkProps: true,
        checkPropsStacked: true,
        tempValue: {},
        currentViewId: null,
        headers: [],
        relevantHeaders: [],
        lookUpInputInfo: {},
        limit: 20,
        skip: 0,
        currentPage: 0,
        forceInputUpdate: {},
        actionHeaders: [
            { key: 'type', type: 'SelectInput', col: '12', information: { type: "local", items: [{ title: 'view', value: 'view' }, { title: 'edit', value: 'edit' }, { title: 'view history', value: 'viewHistory' }, { title: 'remove', value: 'remove' }, { title: 'share', value: 'share' }, { title: 'change stage', value: 'changeStage' }, { title: 'next stage', value: 'nextStage' }, { title: 'send to', value: 'sendTo' }, { title: 'open window', value: 'openWindow' }, { title: 'run flow', value: 'runFlow' }], label: '{{lang}}Action', placeholder: 'Choose...', required: true } },
            {
                key: 'page', type: 'SelectInput', col: '12', information: { label: '{{lang}}pages', type: 'api', address: 'getFrames', filter: { type: 'page' }, fields: { title: 'name', value: '_id' }, placeholder: '{{lang}}pages', required: false }, showMain: false,
                dependencies: [{
                    refKey: 'type', targetKey: 'page',
                    conditions: [{
                        root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'openWindow' } } }, },
                        effect: { show: true, changeHeader: [{ key: 'information.required', value: true }] }
                    }],
                    else: { show: false, changeHeader: [{ key: 'information.required', value: false }] },
                    init: true,
                    // show:true,

                }]

            }
        ],
        actions: {
            // done: { key: "done", label: '{{lang}}Mark as done', color: '#000', bgColor: 'linear-gradient(to right, rgba(70, 133, 204, 0.9), rgba(70, 70, 204, 0.9))', function: this.openEditModal },
            edit: { key: "edit", label: '{{lang}}View / Edit', color: '#000', bgColor: 'linear-gradient(to right, rgba(70, 133, 204, 0.9), rgba(70, 70, 204, 0.9))', function: "openEditModal", icon: '/assets/icons/useful/edit.png' },
            doneTask: { key: "doneTask", label: '{{lang}}DoneTask', color: '#000', bgColor: 'linear-gradient(to right, rgba(70, 133, 204, 0.9), rgba(70, 70, 204, 0.9))', function: "doneTask", icon: importedIcons.changeStage },

            changeStage: { key: "changeStage", label: '{{lang}}Change Stage', sub: true, color: '#000', bgColor: 'linear-gradient(to right, rgba(70, 133, 204, 0.9), rgba(70, 70, 204, 0.9))', function: "changeRecordStageModal", icon: '/assets/icons/useful/route (1).png' },
            nextStage: { key: "nextStage", label: '{{lang}}Next Stage', color: '#000', bgColor: 'linear-gradient(to right, rgba(70, 133, 204, 0.9), rgba(70, 70, 204, 0.9))', function: "nextRecordStage", icon: '/assets/icons/useful/right (1).png' },
            lastStage: { key: "lastStage", label: '{{lang}}Last Stage', color: '#000', bgColor: 'linear-gradient(to right, rgba(70, 133, 204, 0.9), rgba(70, 70, 204, 0.9))', function: "lastRecordStage", icon: '/assets/icons/useful/left.png' },

            subTask: { key: "subTask", label: '{{lang}}Add Sub Task', color: '#000', bgColor: 'linear-gradient(to right, rgba(70, 133, 204, 0.9), rgba(70, 70, 204, 0.9))', function: "addSubTask", icon: importedIcons.tasking },
            sendTo: { key: "sendTo", label: '{{lang}}Send To', sub: true, color: '#000', bgColor: 'linear-gradient(to right, rgba(70, 133, 204, 0.9), rgba(70, 70, 204, 0.9))', function: "sendTo", icon: importedIcons.send },

            request: { key: "request", label: '{{lang}}Request', color: '#000', bgColor: 'linear-gradient(to right, rgba(70, 133, 204, 0.9), rgba(70, 70, 204, 0.9))', function: "openEditModal", icon: importedIcons.request },
            showPage: { key: "showPage", label: '{{lang}}Show Page', color: '#000', bgColor: 'linear-gradient(to right, rgba(70, 133, 204, 0.9), rgba(70, 70, 204, 0.9))', function: "showPage", icon: importedIcons.request },

            openWindow: { key: "openWindow", label: '{{lang}}Open Window', color: '#000', bgColor: 'linear-gradient(to right, rgba(70, 133, 204, 0.9), rgba(70, 70, 204, 0.9))', function: "openWindow", icon: importedIcons.request },
            extra: { key: "extra", label: '{{lang}}Extra', color: '#000', bgColor: 'linear-gradient(to right, rgba(70, 133, 204, 0.9), rgba(70, 70, 204, 0.9))', function: "openEditModal", icon: importedIcons.more },

            remove: { key: "remove", label: '{{lang}}remove', color: '#ee5050', borderTop: '1px solid #eee', function: "openRemoveModal", icon: '/assets/icons/useful/trash.png' },

            duplicate: { key: "duplicate", label: '{{lang}}Duplicate', color: '#000', icon: importedIcons.copy, bgColor: 'linear-gradient(to right, rgba(70, 133, 204, 0.9), rgba(70, 70, 204, 0.9))', function: "duplicateElement" },
            share: { key: "share", label: '{{lang}}Share', color: '#000', bgColor: 'linear-gradient(to right, rgba(70, 133, 204, 0.9), rgba(70, 70, 204, 0.9))', function: "openEditModal", icon: importedIcons.share },
            activityLogs: { key: "activityLogs", label: '{{lang}}Activity Logs', icon: importedIcons.activityLog, color: '#000', bgColor: 'linear-gradient(to right, rgba(70, 133, 204, 0.9), rgba(70, 70, 204, 0.9))', function: "getActivityLogs" },
            setAsHomePage: { key: "setAsHomePage", label: 'Set As Home Page', icon: importedIcons.activityLog, color: '#000', bgColor: 'linear-gradient(to right, rgba(70, 133, 204, 0.9), rgba(70, 70, 204, 0.9))', function: "setAsHomePage" },
            viewHistory: { key: "viewHistory", label: 'View History', icon: importedIcons.activityLog, color: '#000', bgColor: 'linear-gradient(to right, rgba(70, 133, 204, 0.9), rgba(70, 70, 204, 0.9))', function: "openViewHistory" },
            runFlow: { key: "runFlow", label: 'Run Flow', icon: importedIcons.activityLog, color: '#000', bgColor: 'linear-gradient(to right, rgba(70, 133, 204, 0.9), rgba(70, 70, 204, 0.9))', function: "runFlow" },
        },
        // relevantActions: {
        //     // done: { key: "done", label: '{{lang}}Mark as done', color: '#000', bgColor: 'linear-gradient(to right, rgba(70, 133, 204, 0.9), rgba(70, 70, 204, 0.9))', function: this.relevantOpenEditModal },
        //     edit: { key: "edit", label: '{{lang}}View / Edit', color: '#000', bgColor: 'linear-gradient(to right, rgba(70, 133, 204, 0.9), rgba(70, 70, 204, 0.9))', function: "relevantOpenEditModal", icon: importedIcons.edit },

        //     changeStage: { key: "changeStage", label: '{{lang}}Change Stage', sub: true, color: '#000', bgColor: 'linear-gradient(to right, rgba(70, 133, 204, 0.9), rgba(70, 70, 204, 0.9))', function: "changeRecordStageModal", icon: importedIcons.changeStage },
        //     nextStage: { key: "nextStage", label: '{{lang}}Next Stage', color: '#000', bgColor: 'linear-gradient(to right, rgba(70, 133, 204, 0.9), rgba(70, 70, 204, 0.9))', function: "nextRecordStage", icon: importedIcons.changeStage },

        //     subTask: { key: "subTask", label: '{{lang}}Add Sub Task', color: '#000', bgColor: 'linear-gradient(to right, rgba(70, 133, 204, 0.9), rgba(70, 70, 204, 0.9))', function: "addSubTask", icon: importedIcons.tasking },
        //     sendTo: { key: "sendTo", label: '{{lang}}Send To', sub: true, color: '#000', bgColor: 'linear-gradient(to right, rgba(70, 133, 204, 0.9), rgba(70, 70, 204, 0.9))', function: "sendTo", icon: importedIcons.send },

        //     request: { key: "request", label: '{{lang}}Request', color: '#000', bgColor: 'linear-gradient(to right, rgba(70, 133, 204, 0.9), rgba(70, 70, 204, 0.9))', function: "relevantOpenEditModal", icon: importedIcons.request },
        //     extra: { key: "extra", label: '{{lang}}Extra', color: '#000', bgColor: 'linear-gradient(to right, rgba(70, 133, 204, 0.9), rgba(70, 70, 204, 0.9))', function: "relevantOpenEditModal", icon: importedIcons.more },

        //     remove: { key: "remove", label: '{{lang}}remove', color: '#ee5050', borderTop: '1px solid #eee', icon: importedIcons.trash, function: "relevantOpenRemoveModal" },

        //     duplicate: { key: "duplicate", label: '{{lang}}Duplicate', color: '#000', icon: importedIcons.copy, bgColor: 'linear-gradient(to right, rgba(70, 133, 204, 0.9), rgba(70, 70, 204, 0.9))', function: "relevantOpenEditModal" },
        //     share: { key: "share", label: '{{lang}}Share', color: '#000', bgColor: 'linear-gradient(to right, rgba(70, 133, 204, 0.9), rgba(70, 70, 204, 0.9))', function: "relevantOpenEditModal", icon: importedIcons.share },
        //     activityLogs: { key: "activityLogs", label: '{{lang}}Activity Logs', icon: importedIcons.activityLog, color: '#000', bgColor: 'linear-gradient(to right, rgba(70, 133, 204, 0.9), rgba(70, 70, 204, 0.9))', function: "getActivityLogs" },
        // },
        groupBy: [],
        currentView: null,
        // tabs: [
        //     { key: "approval", label: "Approval", icon: "/assets/icons/applets/database/approval.svg" },
        //     { key: "assignee", label: "Assignee", icon: "/assets/icons/applets/database/assignee.svg" },
        //     // { key: "rooms", name: "Rooms", icon: "/assets/icons/rooms/roomcall.svg" },
        // ],
        currentTabs: 'approval',
        taskData: {},
        isLoadingView: false,
        currentHead: {},
        isLoadingAddField: false,
        deleteHeader: false,
        currentRelevantTab: 'details',
        currentRecordStage: '',
        edit: false,
        relevantEdit: false,
        // currentRecordStageIndex: 0,
        isLoadingRemove: false,
        isLoadingFetch: false,
        newInquiry: false,
        editInquiry: false,
        editActions: false,
        showTable: true,
        hasFilter: false,
        filters: {},
        hasSortedBy: false,
        hasGroupBy: false,
        sortedBy: {},
        // tabs:[
        //     {label:'All'},
        // ]
    }

    componentDidMount() {
        // let collections = this.props.modules
        // this.setState({ collections })
        // this.setRelevants()
        let currentFrame = this.props.page
        // if (Array.isArray(this.props.applet?.frames)) {
        //     currentFrame = this.props.applet?.frames[0]?.frame
        // }
        // let headers = []
        // frame.forEach(rowContent => {
        //     let myContent = JSON.parse(JSON.stringify(rowContent))
        //     myContent.col = 12 / frame.length
        //     myContent.key = 'values.' + rowContent.key
        //     myContent.information.disabled = false
        //     myContent.information.inplaceEditable = true
        //     headers.push({ ...myContent })
        // });
        // form.forEach(page => {
        //     page?.pageContent.forEach(pageContent => {
        //         pageContent?.sectionContent.forEach(sectionContent => {
        //             sectionContent.rowContent.forEach(rowContent => {
        //                 let myContent = JSON.parse(JSON.stringify(rowContent))
        //                 myContent.col = 12 / sectionContent.rowContent.length
        //                 myContent.key = 'values.' + rowContent.key
        //                 myContent.information.disabled = false
        //                 headers.push({ ...myContent })
        //             });
        //             // headers.push(header)
        //         });
        //     });
        // });
        // headers = [...headers,...headers]
        let currentView = this.props.page?.views ? this.props.page?.views[0] : null
        let defaultView = currentFrame?.views ? currentFrame?.views[0] : null
        // let currentUserSettings = {}
        // this.props.userSettings.map((element) => {
        //     if (element.frame == this.props.page?._id && element.view == currentView) {
        //         currentUserSettings = element
        //     }
        // })

        // console.log(defaultView)

        this.setState({ currentFrame, currentView, edit: false, relevantEdit: false, editInquiry: false, newInquiry: false, editActions: false }, () => {
            if (defaultView) {
                this.init(null, () => {
                    this.changeView(defaultView, () => { })
                }, true)

            } else {
                this.init()
            }
        })

        document.addEventListener("keydown", this._handleKeyDown);

    }



    componentDidUpdate(prevProps, prevState) {

        // console.log(this.props.page?.pageType)
        // console.log('this.props.page?.key !== this.state.page?.key',this.props.page?.key , this.state.page?.key)
        if (((this.props.page && this.state.page && this.props.page?.key !== this.state.page?.key)) && this.props.page?.pageType == 'collection') {
            //  console.log("this.props.page?.key",this.props.page?.key,this.state.page?.key)

            // console.log(this.props.page?.key)
            // console.log(this.state.page?.key, this.props.page?.key)
            // console.log("HEREE")
            this.setState({
                // page: this.props.page,
                data: [], relevantData: [], totalCount: null,
                currentView: this.props.page.views ? this.props.page.views[0] : null,
                edit: false, relevantEdit: false, newInquiry: false, editActions: false
                // edit: false, relevantEdit: false
            }, () => {

                this.init(true, () => {
                    this.changeView(this.props.page.views ? this.props.page.views[0] : null, () => {
                    })
                }, true)
                // this.setRelevants()
            })
        }

        if (JSON.stringify(this.props.windowData?.path) !== JSON.stringify(prevProps.windowData?.path)) {
            this.setState({

                // currentView: this.props.page?.views ? this.props.page.views[0] : null, // ????

                // data: [],
                // relevantData: [],
                // edit: false, relevantEdit: false,
                // newInquiry: false, editActions: false
                // edit: false, relevantEdit: false
            }, () => {
                // this.changeView(this.props.page.views ? this.props.page.views[0] : null)
                // console.log("HERE")
                this.init()
                // this.setRelevants()
            })
        }
        if (JSON.stringify(this.props.userSettings) != JSON.stringify(prevProps.userSettings)) {
        }
        else if (JSON.stringify(this.props.page?.fields) != JSON.stringify(prevProps.page?.fields)) {
            this.setState({
                data: [], relevantData: [],
                // edit: false, relevantEdit: false
            }, () => {
                this.filterSelectForm()
            })
        }
    }



    componentWillUnmount() {

        document.removeEventListener("keydown", this._handleKeyDown);

    }



    init(force, cb, dontFetch) {
        // console.log("INIT", this.props.page)
        // console.log("INIT", (this.props.page && this.props.page?.key != this.state.page?.key), this.props.page, this.state.page)
        if ((this.props.page && ((this.props.page?._id != this.state.page?._id) || this.props.page?.key != this.state.page?.key)) || force) {
            // let appletHub = typeof this.props.applet?.hub == 'object' ? this.props.applet?.hub?._id : this.props.applet?.hub
            // let variables = {
            //     appletId: this.props.applet?._id,
            //     appletHub: appletHub
            // }
            // console.log("SET PAGE", this.props.setHeader)
            this.setState({ data: [], page: this.props.page }, () => {
                // let filters = this.state?.filters
                // let sortedBy = this.state?.sortedBy
                // console.log('propppppppppppsorted', sortedBy)
                // this.fetchData(filters, true, () => {

                // }, sortedBy)
                // console.log("dontFetch", dontFetch)
                if (!dontFetch) {
                    this.fetchData(null, true)
                }
            })

            this.createParams()


            if (this.props.setHeader) {


                this.props.setHeader({
                    'toolbar': this.toolbarView,
                    toolbarPadding: 10,
                    // 'showToolbar': (this.props.applet && this.props.applet.features && this.props.applet.features[0] == 'Messenger') ? false : true,
                    "showToolbar": true,
                    'title': this.props.page?.name,
                    // 'subtitle': this.props.page?.subtitle,
                    // backAction: (this.props.applet && this.props.applet.features && this.props.applet.features[0] == 'Messenger') ? (() => { this.props.changeMessengerStage('main') }) : false
                })
                // this.props.setHeader('toolbar', this.toolbarView)
                // this.props.setHeader('showToolbar', true)
                // setTimeout(() => {
                //     this.setState({ showStack: true },()=>{
                //         this.props.setHeader('updateId', nanoid())
                //     })
                // }, 2000);
            }

            if (cb) {
                cb()
            }
        }
    }





    createParams = () => {

        let params = Array.isArray(this.props.params) ? this.props.params : []
        let fields = this.props.page?.fields
        if (fields) {

            // let myParams = { label: "Single Record", value: '*record', fields: JSON.parse(JSON.stringify(fields)), info: {} }
            let myParams = { label: "Current Record", value: '*record', fields: JSON.parse(JSON.stringify(fields)), info: {} }


            let foundId = false

            for (let a = 0; a < myParams.fields.length; a++) {
                const element = myParams.fields[a];
                if (element?.key == '_id') {
                    foundId = true
                }
            }

            if (!foundId) {
                myParams.fields.splice(0, 0, { key: '_id', type: 'TextInput', information: { label: '{{lang}}ID', placeholder: '{{lang}}ID' } })
                myParams.fields.push({ key: 'cDate', type: 'DateInput', information: { label: '{{lang}}Creation date', } })
                myParams.fields.push({ key: 'uDate', type: 'DateInput', information: { label: '{{lang}}Update date', } })
            }


            if (myParams) {
                params.splice(0, 0, myParams)
            }
        }

        // console.log(params)

        this.setState({ params })
    }


    _handleKeyDown = (e) => {

        const isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;

        if ((isMac && e.metaKey && e.key === 'f') || (!isMac && e.ctrlKey && e.key === 'f')) {
            this.openFilterView()
            e.preventDefault();
        }
    }


    runFlow = () => {

    }
    // setRelevants = () => {
    //     let relevants = []
    //     if (this.props.modules) {
    //         this.props.modules.forEach(collection => {
    //             if (collection.parents && collection.parents.includes(this.props.page?._id)) {
    //                 relevants.push(collection)
    //             }
    //         });
    //         this.setState({ relevants })
    //     }
    // }

    setAsHomePage = (data, extra) => {
        let body = { applet: this.props.variables?.applet?._id, page: data._id }

        HttpServices.request('setAsHomePage', body, (fetchResult, fetchError) => {
            if (fetchError) {
                this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.loadDataFailed', description: fetchError.message })
                return
            }

            this.props.actions.addNotif({ type: 'success', title: '{{lang}}info.updatedSuccessfully', description: '{{lang}}info.dataUpdatedSuccessfully' })

            this.props.setData('applet.page', fetchResult.info?.page, 'Applet')
            this.init(true)
        })
    }

    setIsLoadingAddField = (isLoading) => {
        this.setState({ isLoadingAddField: isLoading })
    }

    setCurrentHead = (head) => {
        this.setState(({ currentHead: head }))
    }

    sendTo = (prop) => { }



    lastRecordStage = (info) => {

        this.setState({ stageToChange: info, stageAction: 'lastStage' })
        this.memoModal.open()

    }
    nextRecordStage = (info) => {

        this.setState({ stageToChange: info, stageAction: 'nextStage' })
        this.memoModal.open()

    }
    updateStage = () => {
        let body = {}
        let stageToChange = this.state.stageToChange
        let stageAction = this.state.stageAction
        // let currentRecord = this.state.currentRecord
        body.frame = this.props.page._id
        body.record = stageToChange._id
        body.stage = stageToChange['**stage'].value.stage.id
        body.applet = this.props.applet._id
        body.features = this.props.applet.features
        HttpServices.request(stageAction, body, (fetchResult, fetchError) => {
            if (fetchError) {
                return
            }
            if (fetchResult?.info) {
                this.memoModal.close()
                let data = this.state.data
                data.map((element, index) => {
                    if (element._id == fetchResult.info._id) {
                        data[index] = fetchResult.info
                    }
                })
                this.setState({ data, stageAction: null, stageToChange: null })
            }
        })
    }

    changeRecordStageModal = (prop) => {

        this.setState({ currentRecord: prop }, () => {
            if (this.state.currentRecord && this.state.currentRecord['**stage']) {
                this.setState({ currentRecordStage: this.state.currentRecord['**stage'].value.stage.id }, () => {
                })
            }
            else { }
        })
    }
    doneTask = (info, extra) => {
        let body = { _id: info._id }
        HttpServices.request('doneTask', body, (fetchResult, fetchError) => {
            if (fetchError) {
                return
            }
            let data = this.state.data
            for (let index = 0; index < data.length; index++) {
                if (data[index]._id == fetchResult.info._id) {
                    data[index] = fetchResult.info

                }
            }
            this.setState({ data })

        })
    }

    onCreateCollection = () => { }

    toolbarView = () => {
        return (
            <CollectionToolbar setCurrentHead={this.setCurrentHead} currentHead={this.state.currentHead} permissions={this.props.permissions} isMobile={this.props.isMobile} showStack={this.state.showStack} functionsHandler={this.toolbarFunctionsHandler} colors={this.props.colors} language={this.props.language} frame={this.props.page} width={this.props.width} headers={this.props.page?.fields} view={this.state.currentView} hasFilter={this.state.hasFilter} hasSortedBy={this.state.hasSortedBy} hasGroupBy={this.state.hasGroupBy} />
        )
    }

    toolbarFunctionsHandler = (type, name, data, info) => {
        if (this[name]) {
            this[name](data, info)
        }
    }


    defaultCollectionHeader = () => {
        if (this.props.setHeader) {
            this.props.setHeader({
                'toolbar': this.toolbarView,
                toolbarPadding: 10,
                'showToolbar': true,
                'title': this.props.page?.name,
                'subtitle': checkTranslation(this.props.applet?.name),
            })
            // this.props.setHeader('toolbar', this.toolbarView)
            // this.props.setHeader('showToolbar', true)
            // setTimeout(() => {
            //     this.setState({ showStack: true },()=>{
            //         this.props.setHeader('updateId', nanoid())
            //     })
            // }, 2000);
        }
    }


    openWindow = (prop, extra) => {
        // return
        let action = extra.action
        let path = [action.page]

        this.props.changePage(path)


    }


    showPage = (prop, extra) => {


        // console.log("showPage",prop)
        let action = extra.action
        // let path = [action.page]

        let overlayFrames = this.state.overlayFrames ?? []

        let path = [action.page]
        let pageParams = action.pageParams
        let data = extra.data
        path = [...this.props.baseUrl, ...path]
        let pageInfo

        let paramsList = {}

        // console.log("pageParams", pageParams)
        // return

        if (pageParams) {

            for (let i = 0; i < Object.values(pageParams).length; i++) {
                const param = Object.values(pageParams)[i];
                paramsList[param.name] = JSON.parse(JSON.stringify(param))
                // console.log(paramsList[param.name])
                if (/\{\{(.*?)\}\}/.test(String(paramsList[param.name].value))) {
                    // console.log("HERE")
                    let baseValue = String(paramsList[param.name].value).replace(/{/g, '').replace(/}/g, '')
                    // console.log(baseValue)
                    if (baseValue.startsWith('*record')) {
                        baseValue = baseValue.split('.').slice(1).join(".");
                    }
                    // console.log("baseValue", baseValue)
                    let value = getObject(data, baseValue)
                    if (value && typeof value == 'object') {
                        value = value?._id
                    }
                    paramsList[param.name].value = value//checkVariablesListForValue(this.props.params, baseValue)?.data//textVariableReplacer(this.props.fullData, paramsList[param.name], this.props.page?.fields, 'Current Record')

                }
            }



            paramsList = Object.values(paramsList).sort((a, b) => a.index - b.index)
            // console.log("paramsList", paramsList)
            for (let i = 0; i < paramsList.length; i++) {
                const param = paramsList[i];
                if (param.type == 'path') {
                    path.push(param.value)
                } else if (param.type == 'query') {
                    if (!pageInfo) {
                        pageInfo = {}
                    }
                    // console.log(param.name, param.value)
                    pageInfo[param.name] = param.value
                }
            }

        }


        // let newLink = this.props.baseUrl.splice(2)
        // return
        // newLink.push(info.page)
        // newLink.push(prop._id)


        // console.log(path, pageInfo)
        // this.props.changeWindowLink(newLink, pageInfo)



        overlayFrames.push({ type: 'page', id: action.page, path, params: pageInfo })
        // console.log("showPage", prop, extra)
        // console.log("paramsList", paramsList)


        this.setState({ overlayFrames })
    }




    openEditModal = (prop, extra) => {

        // console.log("openEditModal")
        let index = extra.index
        // if (this.props.page?.addNew) {
        //     if (this.props.page?.addNew?.function) {
        //         if (this[this.props.page?.addNew?.function]) {
        //             this[this.props.page?.addNew?.function]()
        //         }
        //     } else if (this.props.page?.addNew?.page) {
        //         let newPage = this.props.route + this.props.page?.addNew.page
        //         this.props.history.push(pathMaker(newPage + '?id=' + prop._id + '&ref=' + pathMaker(this.props.route + '/' + this.props.page?.key)))
        //     }
        //     else {
        //         let newPage = this.props.page?.addNew
        //         if (this.props.page?.addNew.includes('../')) {
        //             newPage = this.props.route + this.props.page?.addNew.replace('..', '')
        //         }
        //         this.props.history.push(pathMaker(newPage + '?id=' + prop._id + '&ref=' + pathMaker(this.props.route + '/' + this.props.page?.key)))
        //     }
        // } else {
        let newLink = this.props.baseUrl.splice(2)
        newLink.push(this.props.page?.key)
        newLink.push(prop._id)

        // if (this.props.page.customEdit) {
        //     let variables = this.props.variables ?? {}
        //     variables.currentItem = prop
        //     // if(this.state.relevantCurrentItem!='details'){
        //     //     variables.currentItem = this.state.relevantCurrentItem
        //     // }
        //     this.setState({ variables })
        //     if (this.props.page.customEdit.function == 'editInquiry') {
        //         this.props.changeWindowLink(newLink, () => {

        //             setTimeout(() => {
        //                 this.setState({ currentItem: prop, currentIndex: index }, () => {
        //                     this.setState({ editInquiry: true }, () => {

        //                     })
        //                 })
        //                 //     // this.setState({ currentItem: data }, () => {
        //                 //         this.setState({ currentItem: prop, currentIndex: index })
        //                 //         this.props.changeWindowLink(newLink)

        //             }, 100);
        //         })
        //         //     // this.itemModal.open()

        //         //     // })
        //         //     // newLink.splice(0, 1)
        //         //     // this.props.changePage(newLink)
        //         //     // this.props.changeStage('singleRecord')

        //     }
        //     else {
        //         // this.props.setData('variables', variables, 'BaseAdminView', () => {
        //         this.props.changeWindowLink(newLink)
        //     }
        //     // })
        // } else {
        this.setState({ currentItem: null }, () => {
            let overlayFrames = this.state.overlayFrames ?? []
            let variables = this.props.variables
            variables.currentItem = prop
            this.setState({ variables })
            // if (Array.isArray(this.state.relevants) && this.state.relevants.length > 0) {
            //     // this.RecordViewerModal.open()
            // this.setState({ relevantEdit: true })

            let params = this.state.params

            if (Array.isArray(params)) {
                for (let i = 0; i < params.length; i++) {
                    let param = params[i];
                    if (param.value == '*record') {
                        param.info = prop
                    }
                }
            }



            overlayFrames.push({ type: 'record', id: 'recordViewer', path: [], params: params })
            // this.setState({ overlayFrames })
            // }
            // else {
            // this.setState({ edit: true })
            // this.itemModal.open()
            // }
            this.setState({ overlayFrames, currentItem: prop, currentIndex: index }, () => {
                // console.log('hereeeeeeeeeeeevvvvvvvvvv',newLink);


                if (this.props.changeWindowLink && !this.props.relevant) {

                    this.props.changeWindowLink(newLink)
                }
            })
        })
        // }
        // this.itemModal.showModal()
        // }
    }




    openViewHistory = (prop, index) => {
        this.setState({ currentItem: prop, currentIndex: index }, () => {
            this.historyViewer.open()
        })
    }
    editField = (data, cb) => {
        data._id = this.props.page._id
        HttpServices.request('updateOneField', data, (fetchResult, fetchError) => {
            if (cb) {
                cb()
            }
            if (fetchError) {
                return
            }
            // let currentFrame = this.state.currentFrame
            // currentFrame.fields = fetchResult.info.fields
            // return
            // let currentView = this.state.currentView
            this.removeSelectedField()
            this.closeFieldsData()
            if (fetchResult.info) {
                let page = this.props.page
                let headers = []
                fetchResult.info.fields.forEach(rowContent => {
                    let myContent = JSON.parse(JSON.stringify(rowContent))
                    if (!myContent.key.includes('values.')) {
                        myContent.key = 'values.' + rowContent.key
                    }
                    headers.push({ ...myContent })
                });
                page.fields = headers
                this.props.setData('page', page, 'BaseAdminView')
                this.props.setData('headers', headers, 'BaseAdminView', () => {
                })
                // this.props.setData('currentFrame', currentFrame)
                // this.setState({ stackedView: false }, () => {
                //     this.setState({ stackedView: true })
                // })
                //   this.hdieAddField()
                this.changeSidebar('fieldsData', 'close')
                this.setViews(fetchResult.info.views)
                // this.setState({ selectedField: {} })
            }

        })
        this.setIsLoadingAddField(false)

    }
    // relevantOpenEditModal = (prop, extra) => {

    //     let index = extra.index

    //     let search = window.location.search
    //     let relevantId = new URLSearchParams(search).get('relevant')
    //     let newLink
    //     newLink = [...this.props.windowData.path]
    //     newLink.splice(0, 2)
    //     newLink.push(prop._id)
    //     // this.setState({ relevantCurrentItem: null }, () => {
    //     //     this.itemModal.open()
    //     //     this.props.changeWindowLink(newLink)
    //     // })
    //     // let search = window.location.search
    //     // let relevantId = new URLSearchParams(search).get('relevant')
    //     let relevantHeaders = this.state.relevantHeaders
    //     this.state.relevants.forEach(rel => {
    //         if (rel._id == relevantId) {
    //             relevantHeaders = rel.fields
    //         }
    //     });
    //     this.setState({ relevantHeaders })
    //     // let newLink = this.props.baseUrl.splice(2)
    //     // newLink.push(this.props.page?.key)
    //     // newLink.push(prop._id)
    //     if (this.props.page.customEdit) {
    //         let variables = this.props.variables
    //         variables.relevantCurrentItem = prop
    //         this.setState({ variables })
    //         this.props.changeWindowLink(newLink)
    //     } else {
    //         this.setState({ relevantCurrentItem: null }, () => {
    //             let variables = this.props.variables
    //             variables.relevantCurrentItem = prop
    //             this.setState({ variables })
    //             // if (this.state.relevants.length > 0) {
    //             // this.RecordViewerModal.open()
    //             // }
    //             // else {
    //             this.setState({ edit: true })
    //             // this.itemModal.open()
    //             // }
    //             this.setState({ relevantCurrentItem: prop, relevantCurrentIndex: index }, () => {
    //             })
    //             this.props.changeWindowLink(newLink)
    //         })
    //     }
    //     // this.itemModal.showModal()
    //     // }
    // }

    fieldOptions = (data) => {
        this.setState({ selectedField: data }, () => {
            this.fieldsData.open()
        })
    }

    insertField = (field, type) => {
        let newField = JSON.parse(JSON.stringify(field)) ?? {}
        newField['**info'] = { insert: type }
        this.setState({ selectedField: newField }, () => {
            this.addField.open()
        })
    }
    duplicateField = (data) => {
        let body = { frame: this.props.page._id, fieldId: data.id }
        HttpServices.request('duplicateFrameField', body, (fetchResult, fetchError) => {
            if (fetchError) {
                return
            }
            if (fetchResult.info) {
                this.setFields(fetchResult.info.fields)
            }
        })
    }
    groupByField = (field) => {
        let group = []
        group.push(field)
        this.changeGroupBy(group)
    }
    sortFieldRecord = (field, type) => {
        let data = this.state.data
        if (['NumberInput', 'DateInput', 'DateTimeInput'].includes(field.type)) {
            switch (type) {
                case 'asc':
                    data.sort((a, b) => {
                        if (!getObject(a, field.key) && !getObject(b, field.key)) {
                            return 0;
                        }
                        if (!getObject(a, field.key)) {
                            return 1;
                        }
                        if (!getObject(b, field.key)) {
                            return -1;
                        }
                        return (getObject(a, field.key) - getObject(b, field.key))
                    })
                    break;
                case 'desc':
                    data.sort((a, b) => {
                        if (!getObject(a, field.key) && !getObject(b, field.key)) {
                            return 0;
                        }
                        if (!getObject(b, field.key)) {
                            return -1;
                        }
                        if (!getObject(a, field.key)) {
                            return 1;
                        }
                        return (getObject(b, field.key) - getObject(a, field.key))
                    })
                    break;
                default:
                    break;
            }

        }
        else if (['TextInput'].includes(field.type)) {
            switch (type) {
                case 'asc':
                    data.sort((a, b) => {
                        if (!getObject(a, field.key)) {
                            return 0
                        }
                        if (!getObject(b, field.key)) {
                            return -1
                        }
                        return getObject(a, field.key).localeCompare(getObject(b, field.key))
                    })
                    break;
                case 'desc':
                    data.sort((a, b) => {
                        if (!getObject(a, field.key)) {
                            return 0
                        }
                        if (!getObject(b, field.key)) {
                            return -1
                        }
                        return getObject(b, field.key).localeCompare(getObject(a, field.key))
                    })
                    break;
                default:
                    break;
            }
        }

        this.setState({ data })
    }

    hideHeaderField = (data) => {
        this.setState({ selectedField: data, deleteHeader: true }, () => {
            this.hideHeaderModal.modal.showModal()
            // this.fieldsData.open()
        })
    }

    deleteHeaderField = (data) => {
        this.setState({ selectedField: data, deleteHeader: true }, () => {
            this.removeHeaderModal.modal.showModal()
            // this.fieldsData.open()
        })
    }

    closeFieldsData = () => {
        this.fieldsData.close()
    }

    openRemoveModal = (prop, extra) => {
        let index = extra.index
        this.removeModal.modal.showModal()
        this.setState({ currentItem: prop, currentIndex: index })
    }

    // relevantOpenRemoveModal = (prop, extra) => {

    //     let index = extra.index
    //     this.removeModal.modal.showModal()
    //     this.setState({ relevantCurrentItem: prop, relevantCurrentIndex: index })
    // }

    getActivityLogs = (prop, index) => {
        let data = {}
        data.record = prop._id
        HttpServices.request('getActivityLogs', data, (fetchResult, fetchError) => {
            if (fetchError) {
                return
            }
            this.setState({ recordLogs: fetchResult.info }, () => {
                this.showActivityLogs.open()
            })
        })
    }

    changeGroupBy = (group) => {
        let keys = []
        let hasGroupBy = this.state.hasGroupBy
        if (Array.isArray(group)) {
            group.forEach(element => {
                if (element.key) {
                    keys.push(element.key)
                } else {
                    keys.push(element)
                }
            });

            let { hasGroupBy } = this.state
            let groupBy = []
            if (Array.isArray(keys) && keys?.length > 0) {
                hasGroupBy = true
                if (Array.isArray(this.props.page?.fields) && this.props.page?.fields?.length > 0) {
                    this.props.page?.fields.forEach(el => {
                        if (keys?.includes(el?.key)) {
                            groupBy.push(el?.information?.label)
                        }
                    });
                }
            } else {
                hasGroupBy = false
            }

            this.setState({ hasGroupBy, groupBy }, () => {
                this.defaultCollectionHeader()
            })
        }

        // return
        this.setViewSettings({ groupBy: JSON.parse(JSON.stringify(keys)) })
        // this.setState({ groupBy: keys })
        // this.setState({ orgData: this.state.data })
        // let data = this.state.orgData ?? this.state.data
        // if (keys.length > 0) {
        //     this.groupBy(0, this.state.data, keys)
        // } else if (this.state.dataReference) {
        //     this.setState({ data: this.state.dataReference })
        // }
    }

    changeFilters = (filters) => {
        let hasFilter = this.state.hasFilter

        // console.log("filters", filters)
        if (filters && Array.isArray(Object.values(filters))) {

            this.setState({ hasFilter, filters }, () => {
                // this.defaultCollectionHeader()
                this.props.setHeader("dummy", 1)
            })
        }
        this.setViewSettings({ filters: JSON.parse(JSON.stringify(filters)) }, true)
        // this.setViewSettings({ hasFilter: JSON.parse(JSON.stringify(hasFilter)) })
    }

    changeSortBy = (sort) => {
        let keys = []
        let hasSortedBy = this.state.hasSortedBy
        // if (Array.isArray(Object.entries(sort)) && Object.entries(sort).length > 0) {
        // Object.entries(sort).forEach(element => {
        //         keys.push(element)
        // });
        if (Object.entries(sort).length > 0) {
            hasSortedBy = true
        } else {
            hasSortedBy = false
        }
        this.setState({ hasSortedBy }, () => {
            this.defaultCollectionHeader()
        })
        // }

        // return
        this.fetchData(null, true, () => {
            this.setViewSettings({ sortedBy: JSON.parse(JSON.stringify(sort)) })
        }, sort)
    }



    addSubTask = (prop) => {
        let taskData = this.state.taskData
        taskData.parent = prop._id
        this.setState({ currentTask: prop, taskData }, () => {
            this.subTaskSide.open()
        })
    }

    submitTask = () => {
        let data = this.subTaskForm.getForm() ?? {}
        data.applet = '{{appletId}}'
        data.frame = '{{frameId}}'
        for (const [key, value] of Object.entries(data)) {
            if (/\{\{(.*?)\}\}/.test(value)) {
                if (this.props.variables) {
                    data[key] = this.props.variables[value.replace(/{/g, '').replace(/}/g, '')]
                }
            }
        }
        if (Object.values(data).length != 0) {
            if (!data.frame) {
                data.frame = this.state.page._id
            }
            HttpServices.request('addTask', data, (fetchResult, fetchError) => {
                if (fetchError) {
                    return
                }
                this.subTaskSide.hideModal()
            })
        }
    }

    openAddView = () => {
        this.addView.openSidebar()
    }

    closeAddView = () => {
        this.addView.closeSidebar()
    }

    hideAddView = () => {
        this.addView.hideModal()
    }

    changeValue = (value) => {
        let tempValue = value
        this.setState({ tempValue }, () => {
        })
    }

    // changeStack = (key) => {
    //     this.setState({ stackedKey: key })
    // }

    changeView = (prop, cb) => {

        // console.log("changeView")
        if (JSON.parse(JSON.stringify(prop))) {
            let page = JSON.parse(JSON.stringify(this.props.page))
            let tempView = JSON.parse(JSON.stringify(prop))
            if (!tempView.settings) {
                tempView.settings = {}
            }
            if (Array.isArray(page.views)) {
                page.views.map((element, index) => {
                    if (tempView.id == element.id) {
                        if (!element.settings) {
                            element.settings = {}
                        }
                        Object.entries(element.settings)?.map(([key, value]) => {
                            tempView.settings[key] = value
                        })
                    }
                })
                if (Array.isArray(this.props.userSettings)) {
                    this.props.userSettings.map((element) => {
                        if (tempView.id == element.view && element.values) {
                            Object.entries(element.values)?.map(([key, value]) => {
                                // if(!tempView.settings[key] || (tempView.settings[key] && Object.values(tempView.settings[key]).length == 0)){
                                if (!tempView.settings[key] && key != "filters") {
                                    tempView.settings[key] = value
                                }
                            })
                        }
                    })
                }
            }
            this.setState({ currentView: JSON.parse(JSON.stringify(tempView)), checkProps: false }, () => {
                let obj = {
                    applet: this.props.applet._id,
                    frame: this.props.page._id,
                    view: this.state.currentView?.id
                }

                this.setState({ checkProps: true })
                let showStack = false
                if (prop.type == 'boards' || prop.type == 'kanban' || prop.type == 'matrix' || prop.type == 'pivot' || prop.type == 'calendar') {
                    showStack = true
                }
                let { hasGroupBy, hasFilter, hasSortedBy } = this.state
                let groupBy = []
                let sortedBy = {}
                let filters = {}

                if (this.state.currentView?.settings && Array.isArray(this.state.currentView?.settings?.groupBy) && this.state.currentView?.settings?.groupBy?.length > 0) {
                    hasGroupBy = true
                    if (Array.isArray(this.props.page?.fields) && this.props.page?.fields?.length > 0) {
                        this.state.currentView?.settings?.groupBy.forEach(el => {
                            this.props.page?.fields.forEach(element => {
                                if (element.key == el) {
                                    groupBy.push(element?.information?.label)
                                }
                            });
                        });
                        // this.props.page?.fields.forEach(el => {
                        //     if (this.state.currentView?.settings?.groupBy?.includes(el?.key)) {
                        //         groupBy.push(el?.information?.label)
                        //     }
                        // });
                    }
                } else {
                    hasGroupBy = false
                }
                if (this.state.currentView?.settings && this.state.currentView?.settings?.sortedBy) {
                    if (Array.isArray(Object.entries(this.state.currentView?.settings?.sortedBy)) && Object.entries(this.state.currentView?.settings?.sortedBy)?.length > 0) {
                        hasSortedBy = true
                        if (Array.isArray(this.props.page?.fields) && this.props.page?.fields?.length > 0) {
                            sortedBy = this.state.currentView?.settings?.sortedBy
                            // this.state.currentView?.settings?.sortedBy.forEach(el => {
                            //     this.props.page?.fields.forEach(element => {
                            //         if (element.key == el) {
                            //             sortedBy.push(element?.information?.label)
                            //         }
                            //     });
                            // });
                            // this.props.page?.fields.forEach(el => {
                            //     if (this.state.currentView?.settings?.groupBy?.includes(el?.key)) {
                            //         groupBy.push(el?.information?.label)
                            //     }
                            // });
                        }
                    } else {
                        hasSortedBy = false
                    }
                }

                // console.log(this.state.currentView)

                if (this.state.currentView?.settings && this.state.currentView?.settings?.filters) {
                    if (this.state.currentView?.settings?.filters && this.state.currentView?.settings?.filters?.root && this.state.currentView.settings?.filters?.root?.conditions && Array.isArray(Object.values(this.state.currentView.settings?.filters?.root?.conditions)) && Object.values(this.state.currentView.settings?.filters?.root?.conditions)?.length > 0) {
                        hasFilter = true
                        filters = this.state.currentView?.settings?.filters
                    } else {
                        hasFilter = false
                    }
                }

                // console.log("filters", filters)
                this.setState({ showStack, hasGroupBy, groupBy, hasFilter, filters, hasSortedBy, sortedBy, }, () => {
                    // this.fetchData(filters, true, ()=>{}, sortedBy)
                    // if (cb) {
                    //     cb()
                    // } else {
                    // console.log("AAA")
                    this.fetchData()
                    // }
                    if (cb) {
                        cb()
                    }
                    // this.setState({ showTable: true })
                    // if (this.props.setHeader) {
                    //     this.props.setHeader("dummy", 1)
                    // }
                    this.props.setHeader('updateId', nanoid())
                })
                // let currentView = JSON.parse(JSON.stringify(this.state.currentView))
                // if (!currentView.settings) {
                //     currentView.settings = {}
                // }
                // if (this.props.userSettings) {
                //     Object.entries(this.props.userSettings?.values ?? {}).map(([key, value]) => {
                //         currentView.settings[key] = value
                //     })
                // }
                // else {
                //     currentView.settings = {}
                // }
                // this.setState({ currentView }, () => {
                // })

                return
                HttpServices.request('getUserSettings', obj, (fetchResult, fetchError) => {
                    if (fetchError) {
                        return
                    }
                    this.setState({ checkProps: true })
                    let showStack = false
                    if (prop.type == 'boards' || prop.type == 'kanban' || prop.type == 'matrix' || prop.type == 'pivot' || prop.type == 'calendar') {
                        showStack = true
                    }
                    this.setState({ showStack }, () => {
                    })
                    let currentView = JSON.parse(JSON.stringify(this.state.currentView))
                    //CHECK
                    if (!currentView.settings) {
                        currentView.settings = {}
                    }
                    if (fetchResult.info) {
                        Object.entries(fetchResult.info?.values ?? {}).map(([key, value]) => {
                            currentView.settings[key] = value
                        })
                    }
                    else {
                        currentView.settings = {}
                    }
                    // currentView = JSON.parse(JSON.stringify(currentView))
                    this.setState({ currentView }, () => {
                        this.props.setHeader('updateId', nanoid())
                    })
                })
            })
        }

    }
    changeSidebar = (ref, func) => {
        this[ref][func]()
    }
    addRecord = (data) => {
        this.addClicked(data)
        // this.openEditModal(data)
    }

    addCustomField = () => {
        this.fieldOptions()
    }

    openAddCustomField = () => {
        this.addField.openSidebar()
    }

    hideAddCustomField = () => {
        this.addField.hideModal()
    }

    openSelectStack = () => {
        this.StackedField.open()
    }

    openFilterView = () => {
        this.FilterEditorModal.open()
    }
    // openPrintView = () => {
    //     this.PrintLabelModal.modal.open()
    // }
    openPrintView = () => {
        this.PrintLabelModal.open()
    }

    openGroupBy = () => {
        this.groupBySide.open()
    }

    openSortBy = () => {
        this.sortBySide.open()
    }

    openCustomizeFields = () => {
        this.customizeFieldsSide.open()
        // this.customizeCardSide.open()
    }

    openRelatedFrames = () => {
        this.relatedFramesSide.open()
        // this.customizeCardSide.open()
    }

    openSynchronizations = () => {
        this.synchronizationsSide.open()
    }


    openCustomizeCard = () => {
        // this.customizeFieldsSide.open()
        this.customizeCardSide.open()
    }


    openImport = () => {
        this.ImportModal.modal.open()
    }

    openAddRelevantCollection = () => {
        this.props.functionsHandler(null, 'changePage', ['settings', 'collections', `new?collection=${this.props.page._id}`], { mode: 'relevant' })
    }


    openRelatedCollections = () => {
        this.props.functionsHandler(null, 'changePage', ['settings', 'collections', `new?collection=${this.props.page._id}`], { mode: 'relevant' })
    }


    openAutomations = () => {


        this.frameAutomationsModal.open()

    }

    openActions = () => {


        this.actionsConfigModal.open()
        // let actionsData = this.props.page.actions
        // if (this.props.setHeader) {
        //     this.props.setHeader({
        //         // 'toolbar': this.toolbarView,
        //         // 'showToolbar': true,
        //         // 'title': this.props.page?.title,
        //         // 'subtitle': this.props.page?.subtitle,
        //         backAction: () => this.setState({ editActions: false, edit: false }, () => {
        //             this.props.setHeader({
        //                 'toolbar': this.toolbarView,
        //                 'showToolbar': (this.props.applet && this.props.applet.features && this.props.applet.features[0] == 'Messenger') ? false : true,
        //                 'title': this.props.page?.title,
        //                 'subtitle': this.props.page?.subtitle,
        //                 backAction: (this.props.applet && this.props.applet.features && this.props.applet.features[0] == 'Messenger') ? (() => { this.props.changeMessengerStage('main') }) : false
        //             })
        //         }),
        //     })

        // }
        // this.setState({ editActions: true })

        // this.frameActions.open()
    }
    addAction = () => {
        this.frameActions.open()
    }
    openExport = () => {
        this.ExportModal.modal.open()
    }

    fetchData = (filter, getCount, cb, sort) => {
        // console.log("fetchData")
        // console.log("fetchData", filter, getCount)
        // console.log(filter, getCount, cb, sort)
        this.setState({ isLoadingData: true })
        let page = this.props.page


        if (!page.fetchUrl) {
            let frameInfo
            if (page.mode) {
                frameInfo = framesConfig[page.mode]
            }
            if (!frameInfo) {
                frameInfo = framesConfig[page.type]
            }
            page = { ...page, ...frameInfo }
        }

        let body = page.filter ? { ...page.filter } : {}

        if (this.props.filter) {
            if (!body.filter) {
                body.filter = {}
            }
            body.filter = { ...body.filter, ...this.props.filter }
        }

        if (page && page.fetchUrl) {
            body.limit = this.state.limit
            body.skip = this.state.currentPage
            // body.page = page.key
            // console.log(body, this.props.variables)
            for (const [key, value] of Object.entries(body)) {
                if (/\{\{(.*?)\}\}/.test(value)) {
                    if (this.props.variables) {
                        body[key] = this.props.variables[value.replace(/{/g, '').replace(/}/g, '')]
                    }
                }
            }
            if (this.state.totalCount == null || getCount) {
                body.getCount = true
            }
            body.frame = this.props.page?._id
            body.filter = body.filter ?? {}
            // let customFilter = this.state.filters
            // if (customFilter != undefined) {

            //     body.filter = customFilter
            // } else {
            // if (this.state.currentView?.settings?.filters && Object.values(this.state.currentView?.settings.filters).length > 0) {
            //     body.filter = this.state.currentView?.settings.filters
            // } else {

            if (this.state.filters && Object.values(this.state.filters).length > 0) {
                body.filter = { ...body.filter, ...this.state.filters }
            }
            // }
            // }
            if (sort) {

                body.sort = sort

            } else {
                if (this.state.currentView?.settings?.sortedBy) {
                    body.sort = this.state.currentView?.settings?.sortedBy
                }
            }
            if (Array.isArray(body.sort)) {
                delete body.sort
            }


            // console.log('FETCH', page.fetchUrl, body)


            HttpServices.request(page.fetchUrl, body, (fetchResult, fetchError) => {


                // console.log('FETCH', fetchResult, fetchError);

                if (fetchError) {

                    this.setState({ isLoadingData: false })
                    if (cb) {
                        cb()
                    }

                    this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.loadDataFailed', description: fetchError.message })
                    return
                }
                if (fetchResult) {
                    let { hasFilter, filters } = this.state
                    if (filter != 'undefined' && filter != null) {
                        filters = filter
                    }
                    this.setState({ filters }, () => {
                        if ((this.state.filters && this.state.filters?.root && this.state.filters?.root?.conditions)) {
                            if (Object.keys(this.state.filters?.root?.conditions)?.length == 0) {
                                hasFilter = false
                            }
                            else {
                                hasFilter = true
                            }
                        } else {
                            hasFilter = false
                        }
                    })
                    this.setState({ data: fetchResult.info, showTable: false, hasFilter }, () => {
                        this.defaultCollectionHeader()
                        this.setState({ showTable: true, isLoadingData: false }, () => {
                            if (fetchResult.count != null) {
                                this.setState({ totalCount: fetchResult.count })
                            }
                            if (cb) {
                                cb()
                            }
                            // let keys = ["values.d78c13e6-bbc8-48bc-8ab4-ff22cbb9c06c", "values.d7caac63-ed2e-454b-aaec-8c06c26e0da4", "values.92e053a5-6f21-4e77-b7c2-638749485a33"]
                        })
                    })
                }
            })
        }
    }

    // fetchRelevantData = (relevantRecords) => {
    //     this.setState({ isLoadingData: true })
    //     let body = this.props.page.filter ? { ...this.props.page.filter } : {}
    //     let page = this.props.page
    //     // body.page = page.key
    //     for (const [key, value] of Object.entries(body)) {
    //         if (/\{\{(.*?)\}\}/.test(value)) {
    //             if (this.props.variables) {
    //                 body[key] = this.props.variables[value.replace(/{/g, '').replace(/}/g, '')]
    //             }
    //         }
    //     }
    //     body.frame = this.state.currentRelevantTab
    //     body.relevant = true
    //     body.relevantRecords = relevantRecords
    //     HttpServices.request(page.fetchUrl, body, (fetchResult, fetchError) => {
    //         this.setState({ isLoadingData: false })
    //         if (fetchError) {
    //             this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.loadDataFailed', description: fetchError.message })
    //             return
    //         }
    //         this.setState({ showTable: false }, () => {
    //             this.setState({ relevantData: fetchResult.info, showTable: true }, () => {
    //                 // let keys = ["values.d78c13e6-bbc8-48bc-8ab4-ff22cbb9c06c", "values.d7caac63-ed2e-454b-aaec-8c06c26e0da4", "values.92e053a5-6f21-4e77-b7c2-638749485a33"]
    //             })
    //         })
    //     })
    // }

    fetchHeaderRemove = () => {
        this.setState({ isLoadingRemove: true })
        let body = {}
        body.field = this.state.selectedField
        body._id = this.props.page._id
        // console.log('dsvlsndslkvnslvns',body);
        // return
        HttpServices.request('removeFieldFrame', body, (fetchResult, fetchError) => {
            this.setState({ isLoadingRemove: false })
            if (fetchError) {
                this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.removeFailed', description: fetchError.message })
                return
            }
            let page = this.props.page
            let headers = []
            fetchResult.info.fields.forEach(rowContent => {
                let myContent = JSON.parse(JSON.stringify(rowContent))
                if (!myContent.key.includes('values.')) {
                    myContent.key = 'values.' + rowContent.key
                }
                headers.push({ ...myContent })
            });
            page.fields = headers
            this.props.setData('page', page, 'BaseAdminView')
            this.props.setData('headers', headers, 'BaseAdminView', () => {
            })
            this.removeHeaderModal.hideModal()
            // let data = JSON.parse(JSON.stringify(this.state.data))
            // data.splice(this.state.currentIndex, 1)
            // this.setState({ data }, () => {
            // })
            // this.removeModal.modal.hideModal()
            // this.props.actions.addNotif({ type: 'success', title: '{{lang}}info.removedSuccesfully', description: '{{lang}}info.dataRemovedSuccessfully' })
        })
    }

    fetchHeaderHide = () => {
        // console.log("fetchHeaderHide")
        this.setState({ isLoadingHide: true })
        let body = {}
        let selectedField = JSON.parse(JSON.stringify(this.state.selectedField))
        body.fields = JSON.parse(JSON.stringify(this.props.page?.fields))
        body.fields.map((element) => {
            if (element.key == selectedField.key) {
                element.showMain = false
            }
        })
        body.view = this.state.currentView.id
        body.setting = 'customized'
        body._id = this.props.page._id
        HttpServices.request('updateFieldsView', body, (fetchResult, fetchError) => {
            this.setState({ isLoadingRemove: false })
            if (fetchError) {
                this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.removeFailed', description: fetchError.message })
                return
            }
            if (fetchResult.info) {
                this.setViews(fetchResult.info.views)
            }
            this.hideHeaderModal.modal.hideModal()
            this.props.actions.addNotif({ type: 'success', title: '{{lang}}info.removedSuccesfully', description: '{{lang}}info.dataRemovedSuccessfully' })
        })
    }

    fetchRemove = () => {
        this.setState({ isLoadingRemove: true })
        let id = this.state.currentItem._id
        let body = this.props.page?.removeBody ?? {}
        body.id = id

        for (const [key, value] of Object.entries(body)) {
            if (/\{\{(.*?)\}\}/.test(value)) {
                if (this.props.variables) {
                    body[key] = this.props.variables[value.replace(/{/g, '').replace(/}/g, '')]
                }
            }
        }

        HttpServices.request(this.props.page.removeUrl, body, (fetchResult, fetchError) => {
            this.setState({ isLoadingRemove: false })
            if (fetchError) {
                this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.removeFailed', description: fetchError.message })
                return
            }
            let data = JSON.parse(JSON.stringify(this.state.data))
            data.splice(this.state.currentIndex, 1)
            this.setState({ data }, () => {
            })
            this.removeModal.modal.hideModal()
            this.props.actions.addNotif({ type: 'success', title: '{{lang}}info.removedSuccesfully', description: '{{lang}}info.dataRemovedSuccessfully' })
        })
    }

    // fetchRelevantRemove = () => {
    //     this.setState({ isLoadingRemove: true })
    //     let id = this.state.relevantCurrentItem._id
    //     HttpServices.request(this.props.page.removeUrl, { "id": id }, (fetchResult, fetchError) => {
    //         this.setState({ isLoadingRemove: false })
    //         if (fetchError) {
    //             this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.removeFailed', description: fetchError.message })
    //             return
    //         }
    //         let relevantData = JSON.parse(JSON.stringify(this.state.relevantData))
    //         relevantData.splice(this.state.relevantCurrentIndex, 1)
    //         this.setState({ relevantData }, () => {
    //         })
    //         this.removeModal.modal.hideModal()
    //         this.props.actions.addNotif({ type: 'success', title: '{{lang}}info.removedSuccesfully', description: '{{lang}}info.dataRemovedSuccessfully' })
    //     })
    // }

    checkDecisions = (path, decisions, cb) => {
        if (Object.values(decisions).length != 0) {
            let newObjcet = {}
            path.forEach((element) => {
                if (decisions[element.key]) {
                    newObjcet[element.key] = element.key
                }
            })
            this.setState({ decisions }, () => {
                cb()
            })
        }
        else {
            cb()
        }
    }

    choosePath = (path, decisions) => {
        this.checkDecisions(path, decisions, () => {
            let body = {}
            let currentRecord = this.state.currentRecord
            body.frame = this.state.currentFrame._id ?? this.state.currentFrame
            body.record = currentRecord._id
            body.stage = currentRecord['**stage'].value.stage.id
            body.target = this.state.targetStage
            body.correctPath = path
            body.applet = this.props.applet._id
            body.features = this.props.applet.features
            HttpServices.request('changeStage', body, (fetchResult, fetchError) => {
                if (fetchError) {
                    return
                }
                this.props.actions.addNotif({ type: 'success', title: '{{lang}}info.postDataSuccesfully', description: '{{lang}}info.dataUpdatedSuccessfully' })
                // let data = this.state.data
                // for (let i = 0; i < data.length; i++) {
                //     if (data[i]._id == fetchResult.info._id) {
                //         data[i] = fetchResult.info
                //     }
                // }
                // this.setState({ data: fetchResult.info }, () => {
                // })
            })
        })
    }

    changeRecordStage = (prop, index) => {

        let body = {}
        let data = JSON.parse(JSON.stringify(this.state.data))
        let automations = this.state.currentRecord['**stage']?.information?.workflow
        let currentRecord = this.state.currentRecord
        // body.frame = this.state.currentFrame._id ?? this.state.currentFrame
        // body.frame = this.props
        body.record = currentRecord._id
        body.stage = currentRecord['**stage'].value.stage.id
        body.target = prop.id
        let paths = []
        let decisions = {}
        let currentStage = automations.flow.components[body.stage]
        let sharedData = { condition: false }
        checkRigram(currentStage, 0, automations, body.target, decisions, paths, sharedData, [], () => {
            if (paths.length > 1 && !sharedData?.condition) {
                this.setState({ selectPath: paths, allDecisions: decisions, targetStage: prop.id }, () => {
                    this.stageSide.close()
                    this.selectPathSidebar.open()
                })
            }
            else {
                this.checkDecisions(paths[0], decisions, () => {
                    body.paths = paths[0]
                    body.correctPath = paths[0]
                    body.applet = this.props.applet._id
                    body.features = this.props.applet.features
                    HttpServices.request('changeStage', body, (fetchResult, fetchError) => {


                        if (fetchError) {
                            return
                        }
                        if (fetchResult) {
                            for (let i = 0; i < data.length; i++) {
                                if (data[i]._id == fetchResult.info._id) {
                                    data[i] = fetchResult.info
                                }
                            }
                            this.setState({ currentRecordStage: prop.id, data })
                        }
                        this.props.actions.addNotif({ type: 'success', title: '{{lang}}info.postDataSuccesfully', description: '{{lang}}info.dataUpdatedSuccessfully' })
                        // this.setState({ data: fetchResult.info }, () => {
                        // })
                    })
                })
            }
            // this.setState({ data: fetchResult.info }, () => {})
        })
    }

    addClicked = (data) => {


        if (this.props.relevant?.initData) {
            data = this.props.relevant?.initData
        }
        // console.log("addClicked")
        let overlayFrames = this.state.overlayFrames ?? []
        let newLink
        // let admin = this.props.baseUrl.filter(item => item === 'admin')
        // if (admin.length > 0) {
        newLink = this.props.baseUrl.splice(2)
        // }
        // else {
        //     newLink = this.props.baseUrl.splice(1)
        // }
        newLink.push(this.props.page?.key)
        newLink.push('new')
        // if (this.props.page.addNew) {

        if (this.props.page.customAdd) {
            if (this.props.page.customAdd.function == 'openConnectionModal') {
                this.addUserModal.showModal()
            }
            else if (this.props.page.customAdd.function == "openInviteUser") {
                this.setState({ currentItem: data }, () => {
                    this.addUserSidebar.openSidebar()
                })
            }
            else if (this.props.page.customAdd.function == "addInquiry") {
                // this.itemModal.close()
                this.setState({ currentItem: data }, () => {
                    // this.setState({ newInquiry: true })
                    this.itemModal.open()
                    // this.itemModal.hideModal()
                    this.props.changeWindowLink(newLink)
                })
                // this.props.changeStage('newInquery')
            }
            else if (this.props.page.customAdd.function == "changeNavigationsView") {
                this.props.changeWindowLink(newLink)

                if (this.props.changeStage) {
                    this.props.changeStage('navigation')
                }
            }
            else if (this.props.page.customAdd.function == "changeChannels") {
                this.props.changeWindowLink(newLink)

                if (this.props.changeStage) {
                    this.props.changeStage('channels')
                }
            }
            // else if (this.props.page.customAdd.function == 'changeStage') {
            //     newLink.splice(0,1)
            //     this.props.functionsHandler(null, 'changeStage', 'singleRecord')
            // }
            else {
                this.props.changeWindowLink(newLink)
            }
        } else {
            this.setState({ currentItem: data }, () => {

                overlayFrames.push({ type: 'record', id: 'recordViewer', path: [], params: null })
                // console.log("showPage", prop, extra)
                // console.log("paramsList", paramsList)


                this.setState({ overlayFrames })

                // this.setState({ edit: true })
                // this.itemModal.open()
                if (!this.props.relevant) {
                    this.props.changeWindowLink(newLink)
                }
            })
        }
    }



    closeOverlayFrame = (data) => {

        let overlayFrames = this.state.overlayFrames ?? []
        for (let i = overlayFrames.length - 1; i >= 0; i--) {
            const overlayFrame = overlayFrames[i];

            if (overlayFrame.id == data.id) {
                overlayFrames.splice(i, 1)
            }
        }



        // let newLink
        // let path = [...this.props.windowData.path]

        if (!this.props.relevant) {
            let newLink = [...this.props.baseUrl]
            newLink.splice(0, this.props.baseUrl?.length - 2)
            newLink.push(this.props.page?.key)
            this.props.changeWindowLink(newLink)
        }

        // console.log("overlayFrames",overlayFrames)

        this.setState({ overlayFrames })

    }

    // relevantAddClicked = () => {
    //     let search = window.location.search
    //     let relevantId = new URLSearchParams(search).get('relevant')
    //     let relevantHeaders = this.state.relevantHeaders
    //     this.state.relevants.forEach(rel => {
    //         if (rel._id == relevantId) {
    //             relevantHeaders = rel.fields
    //         }
    //     });
    //     this.setState({ relevantHeaders }, () => {
    //         let newLink
    //         newLink = [...this.props.windowData.path]
    //         newLink.splice(0, 2)
    //         newLink.push('new')
    //         this.setState({ relevantCurrentItem: null, relevant: true }, () => {
    //             this.setState({ edit: true })
    //             // this.itemModal.open()
    //             this.props.changeWindowLink(newLink)
    //         })
    //     })
    // }

    itemModalClosed = () => {
        // let newLink
        // let path = [...this.props.windowData.path]
        // if (Array.isArray(this.state.relevants) && this.state.relevants.length > 0) {
        //     newLink = path
        //     if (path[0] != 'admin') {
        //         newLink.splice(0, 2)
        //         newLink.pop()
        //         // if (newLink.length == 3) {
        //         //     newLink.pop()
        //         // }
        //     }
        //     this.setState({ relevantHeaders: [] })
        // }
        // else {
        //     newLink = this.props.baseUrl
        //     newLink = this.props.baseUrl.splice(2)
        //     // newLink.push('admin')
        //     // newLink.push(path[0])
        //     // newLink.push(path[1])
        //     // if (path[2] == 'admin') {
        //     //     newLink.push('admin')
        //     // }
        //     newLink.push(this.props.page?.key)
        // }
        // this.props.changeWindowLink(newLink)
    }

    inquiryClosed = () => {
        let newLink
        // if (this.state.relevants.length > 0) {
        //     let path = [...this.props.windowData.path]
        //     newLink = path
        //     if (path[0] != 'admin') {
        //         newLink.splice(0, 2)
        //         newLink.pop()
        //         // if (newLink.length == 3) {
        //         //     newLink.pop()
        //         // }
        //     }
        //     this.setState({ relevantHeaders: [] })
        // }
        // else {
        newLink = this.props.baseUrl
        newLink = this.props.baseUrl.splice(2)
        newLink.push('admin')
        newLink.push(this.props.page?.key)
        // }
        this.props.changeWindowLink(newLink)
    }

    clearTempValue = () => {
        this.setState({ tempValue: {} })
    }

    updateRecord = (data, key) => {
        // let tempValue = this.state.tempValue
        let tempValue = this.state.tempValue ?? {}
        // if (Object.values(tempValue).length == 0) {
        tempValue[key] = data
        this.setState({ tempValue }, () => {
            // }
            if (this.state.tempValue[key]?.newData != this.state.tempValue[key]?.initData) {
                this.sendUpdateRecord(key, tempValue)
            }
            else {
                this.setState({ tempValue: {} })
            }
        })
    }

    sendUpdateRecord = (key, value) => {
        if (SocketServices.socket?.connect) {
            let frame = this.state.currentFrame._id ?? this.state.currentFrame
            SocketServices.emit('updateRecord', { frame, applet: this.props.applet?._id, value: value[key] }, null, (info) => {
                let data = this.state.data
                data.forEach((prop) => {
                    if (prop._id == info._id) {
                        let vKey = value[key].key.split('.').at(-1)
                        prop.values[vKey] = info.values[vKey]
                    }
                })
                let tempValue = this.state.tempValue
                delete tempValue[key]
                this.setState({ data, tempValue }, () => {
                    // this.setState({ tempValue })
                })
            })
        }
    }

    updateField = (data) => {
        HttpServices.request('updateOneField', data, (fetchResult, fetchError) => {
            if (fetchError) {
                this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.postFailed', description: fetchError.message })
                return
            }
            let currentFrame = this.state.currentFrame
            currentFrame.fields = fetchResult.info.fields
            this.setCurrentForm('currentFrame', currentFrame)
            this.setState({ checkPropsStacked: !this.state.checkPropsStacked })
            this.fieldsData.close()
        })
    }

    itemAdded = (newItem) => {
        let newData = JSON.parse(JSON.stringify(this.state.orgData ?? this.state.data))
        newData.splice(0, 0, newItem)
        if (this.state.currentPage == 0 && newData.length > this.state.limit) {
            newData.pop()
        }
        newData = JSON.parse(JSON.stringify(newData))
        this.setState({ data: newData }, () => {
            // this.groupBy(0, this.state.data, this.state.groupBy)
        })
    }

    relevantItemAdded = (newItem) => {
        let newData = this.state.relevantData
        newData.splice(0, 0, newItem)
        newData = JSON.parse(JSON.stringify(newData))
        this.setState({ relevantData: newData }, () => { })
    }

    itemEdited = (editedItem) => {
        // let data = this.state.orgData ?? this.state.data
        let data = this.state.data
        data.forEach((element, index) => {
            let id = element?.id ?? element?._id
            let currentId = this.state.currentItem?.id ?? this.state.currentItem?._id
            if (id === currentId) {
                data[index] = Object.assign({}, editedItem)
            }
        });
        this.setState({ data, }, () => {
            // this.setState({ data, orgData: data }, () => {
            // this.groupBy(0, this.state.data, this.state.groupBy)
            // this.TableViewer.forceUpdateData()
        })
    }

    relevantItemEdited = (editedItem) => {
        let relevantData = this.state.relevantData ?? []
        relevantData.forEach((element, index) => {
            let id = element?.id ?? element?._id
            let currentId = this.state.relevantCurrentItem?.id ?? this.state.relevantCurrentItem?._id
            if (id === currentId) {
                relevantData[index] = Object.assign({}, editedItem)
            }
        });
        this.setState({ relevantData }, () => {
            // this.groupBy(0, this.state.data, this.state.groupBy)
            // this.TableViewer.forceUpdateData()
        })
    }

    // updateData = (data) => {
    //     this.setState(data)
    // }

    // functionsHandler = (prop, index, reference) => {
    //     if (this[reference.function]) {
    //         this[reference.function](prop, index, reference)
    //     }
    // }

    functionsHandler = (type, name, data, extra, cb) => {

        // console.log('hereeeeeeeeeeeevvvvvvvvvv',type, name, data, extra);

        if (!type || type == 'frame' || type == 'collection') {
            if (this[name]) {
                this[name](data, extra, cb)
            }
        } else {
            this.props.functionsHandler(type, name, data, extra, cb)
        }
    }

    creatAddView = (data, extra) => {
        let body = {
            view: data.type,
            name: data.name,
            form: this.props.page?._id ?? this.props.page
        }
        HttpServices.request('addView', body, (fetchResult, fetchError) => {
            if (fetchError) {
                return
            }
            // this.props.setData('currentFrame', fetchResult.info)
            let page = this.props.page
            page.views = fetchResult.info.views
            this.props.setData('page', page, 'BaseAdminView')
            this.hideAddView()
            this.setState({ isLoadingView: false })
        })
    }

    groupBy = (keyIndex = 0, data = this.state.data, keys) => {
        let dataReference = this.state.dataReference
        if (!dataReference) {
            dataReference = JSON.parse(JSON.stringify(this.state.data))
            this.setState({ dataReference: dataReference })
        }

        // if(keyIndex ==0){}
        if (keys && keys.length > 0) {
            // if (keyIndex == 0) {
            //     this.setState({ orgData: this.state.data })
            // }
            let group = {}
            let headers = this.props.page?.fields

            // let data = this.state.data
            if (data) {
                // keys.forEach((key, index) => {
                let key = keys[keyIndex]
                let header
                headers.forEach(element => {
                    if (key == element.key) {
                        header = element
                    }
                });
                if (Array.isArray(data)) {
                    data.forEach(element => {
                        let value = getObject(element, key)
                        if (Array.isArray(value)) {
                            value = value[value.length - 1]
                        }
                        value = String(value)
                        if (!group[value]) {
                            group[value] = { data: [], header, id: nanoid() }
                        }
                        group[value].data.push(element)
                    });
                } else {
                    // let value = String(getObject(data, key))
                    // if (!group[value]) {
                    //     group[value] = []
                    // }
                    // group[value].push(data)
                }
                // });
                if (keyIndex != keys.length - 1) {
                    // return group
                    // } else {
                    for (const [groupKey, groupValues] of Object.entries(group)) {
                        group[groupKey] = { header, id: nanoid(), data: this.groupBy(keyIndex + 1, groupValues.data, keys) }
                    }
                }

                // else{}
                if (keyIndex == 0) {
                    this.setState({ data: group })
                }
                return group
            }
        }
    }



    addNewForm = () => {
        this.props.changeWindowLink(['settings', 'newForm'])
        this.props.changeStage('settings')
    }



    addNewPage = () => {
        this.props.changeWindowLink(['settings', 'newPage'])
        this.props.changeStage('settings')
    }



    filterSelectForm = (current) => {
        let fields = this.state.currentFrame?.fields
        let headers = []

        if (Array.isArray(fields)) {
            fields.forEach(rowContent => {
                let myContent = JSON.parse(JSON.stringify(rowContent))
                myContent.col = 12 / fields.length
                myContent.key = 'values.' + rowContent.key
                if (!myContent.information) {
                    myContent.information = {}
                }
                myContent.information.disabled = false
                // myContent.information.inplaceEditable = true
                headers.push({ ...myContent })
            });
        }
        // if (Array.isArray(form)) {
        //     form.forEach(page => {
        //         page?.pageContent.forEach(pageContent => {
        //             pageContent?.sectionContent.forEach(sectionContent => {
        //                 sectionContent.rowContent.forEach(rowContent => {
        //                     let myContent = JSON.parse(JSON.stringify(rowContent))
        //                     myContent.col = 12 / sectionContent.rowContent.length
        //                     myContent.key = 'values.' + rowContent.key
        //                     myContent.information.disabled = false
        //                     headers.push({ ...myContent })
        //                 });
        //                 // headers.push(header)
        //             });
        //         });
        //     });
        // }
        // headers = [...headers,...headers]
        this.setState({ headers }, () => {
            this.init()
            // this.fetchData()
        })
    }

    setCurrentForm = (key, value) => {
        this.setState({ [key]: value }, () => {
            if (this.props.setCurrentForm) {
                this.props.setCurrentForm(value)
            }
            this.filterSelectForm(this.state.currentFrame)
        })
    }

    changePage = (data, info) => {
        this.props.changePage(data, info)
        // window.history.pushState(null, null, `${path}/settings`)
        // window.location.reload()
        // this.props.changeWindowLink(['settings'])
        // this.props.changeStage('settings')
    }

    saveUserSettings = (data) => {
        if (SocketServices.socket?.connected) {
            SocketServices.emit('userSettings', { data, frame: this.props.page._id, view: this.state.currentView?.id, applet: this.props.applet?._id, for: 'user' }, null, (info) => {
                if (info) {
                    if (this.props.updateUserSettings) {
                        this.props.updateUserSettings(info)
                    }
                }
            })
        }
    }

    changeTabs = (prop) => {
        this.setState({ currentTabs: prop.key })
        this.stageManager.changeStage(prop.key)
    }

    handleCopy = (item) => {
        navigator.clipboard.writeText(item);
        this.props.actions.addNotif({ type: 'success', title: 'Successfuly Copied!', description: 'Information Successfuly Copied.' })
    }

    setStackedKey = (key) => {
        let currentView = this.state.currentView
        let page = this.props.page
        page.views.forEach((element, index) => {
            if (element.id == currentView.id) {
                if (!currentView.settings) {
                    currentView.settings = {}
                }
                currentView.settings.stacked = key
                // currentView = page.views[index]
            }
        });
        this.props.setData('page', page, 'BaseAdminView')
        this.setState({ currentView, checkProps: !this.state.checkProps })
    }

    setViews = (views) => {

        this.props.updateFrameInfo('views', views)

        // let page = JSON.parse(JSON.stringify(this.props.page))
        let currentView = JSON.parse(JSON.stringify(this.state.currentView))

        views.map((view) => {
            if (currentView.id == view.id) {

                this.setState({ currentView: view })

            }
        })





    }

    // setViews = (viewSettings) => {
    //     let page = JSON.parse(JSON.stringify(this.props.page))
    //     let currentView = JSON.parse(JSON.stringify(this.state.currentView))
    //     // page.views = views

    //     // console.log("viewSettings",viewSettings)

    //     // console.log()
    //     return
    //     if (Array.isArray(page.views)) {
    //         page.views.map((element) => {
    //             if (currentView.id == element.id) {
    //                 if (!currentView.settings) {
    //                     currentView.settings = {}
    //                 }
    //                 Object.entries(element.settings ?? {}).map(([key, value]) => {
    //                     currentView.settings[key] = viewSettings[key]
    //                 })
    //             }
    //         })
    //     }
    //     console.log("currentView",currentView)
    //     this.props.setData('page', page, 'BaseAdminView')
    //     this.setState({ currentView }, () => {
    //     })
    //     // page.view
    //     // page.views = headers

    // }
    setFields = (fields) => {

        let page = this.props.page
        let headers = []
        fields.forEach(rowContent => {
            let myContent = JSON.parse(JSON.stringify(rowContent))
            if (!rowContent.key.includes('values.')) {
                myContent.key = 'values.' + rowContent.key
            }
            headers.push({ ...myContent })
        });
        page.fields = headers
        this.props.setData('page', page, 'BaseAdminView')
        this.props.setData('headers', headers, 'BaseAdminView', () => {
        })
    }
    setViewSettings = (settings, dontSaveInServer) => {

        let view = JSON.parse(JSON.stringify(this.state.currentView))
        if (!view) {
            view = { settings: {} }
        }
        if (!view.settings) {
            view.settings = {}
        }
        for (const [key, value] of Object.entries(settings)) {
            view.settings[key] = value
        }
        // return

        // return
        this.setState({ currentView: JSON.parse(JSON.stringify(view)) }, () => {
            if (this.props.updateFrameInfo) {
                this.props.page?.views?.forEach((mview, index) => {
                    if (mview.id == this.state.currentView?.id) {
                        this.props.page.views[index] = this.state.currentView
                    }

                });


                this.props.updateFrameInfo('views', this.props.page?.views)

            }
            if (this.props.setHeader) {
                this.props.setHeader("dummy", 1)
            }
            // this.state.currentView.settings.sortedBy={}
            if (!dontSaveInServer && SocketServices.socket.connect) {
                let obj = {
                    for: 'user',
                    applet: this.props.applet._id,
                    view: view.id,
                    frame: this.props.page._id,
                    // category: this.props.applet.features[0],
                    data: this.state.currentView.settings
                }
                SocketServices.emit('userSettings', obj, null, (info, err) => {
                    // if (info.values) {
                    //     let currentView = JSON.parse(JSON.stringify(this.state.currentView))
                    //     currentView.settings = JSON.parse(JSON.stringify(info.values))
                    //     this.setState({ currentView }, () => {
                    //     })
                    // }
                });
            }
        })
    }

    closeSide = (name) => {
        if (this[name]) {
            this[name].close()
        }
    }

    setData = (key, value, reference, cb) => {
        if (reference == 'CollectionView') {
            this.setState({ [key]: value }, () => {
                if (cb) {
                    cb()
                }
            })
        }
        else {
            if (this.props.setData) {
                this.props.setData(key, value, reference, () => {
                })
            }
        }
    }

    addFieldInput = (data, cb) => {
        data.frame = this.props.page._id
        data.lastField = this.state.selectedField
        // console.log("data",data)
        HttpServices.request('addFieldFrame', data, (fetchResult, fetchError) => {
            if (cb) {
                cb()
            }
            if (fetchError) {
                return
            }
            // let currentFrame = this.state.currentFrame
            // currentFrame.fields = fetchResult.info.fields
            // return
            // let currentView = this.state.currentView
            let page = this.props.page
            let headers = []
            fetchResult.info.fields.forEach(rowContent => {
                let myContent = JSON.parse(JSON.stringify(rowContent))
                if (!myContent.key.includes('values.')) {
                    myContent.key = 'values.' + rowContent.key
                }
                headers.push({ ...myContent })
            });
            page.fields = headers
            this.removeSelectedField()
            this.props.setData('page', page, 'BaseAdminView')
            this.props.setData('headers', headers, 'BaseAdminView', () => {
            })
            // this.props.setData('currentFrame', currentFrame)
            // this.setState({ stackedView: false }, () => {
            //     this.setState({ stackedView: true })
            // })
            //   this.hdieAddField()
            this.hideAddCustomField()
        })
        this.setIsLoadingAddField(false)
    }

    addNewLookUp = (data) => {
        this.setState({ isLoadingFetch: true }, () => {
            HttpServices.request('getFrameFields', { _id: data.frame, needApplet: true }, (fetchResult, fetchError) => {
                this.setState({ isLoadingFetch: false })
                if (fetchError) {
                    return
                }
                let lookUpInputInfo = { fields: fetchResult.info.fields, applet: fetchResult.info?.applet?._id, headerKey: data.headerKey, frame: data.frame, postUrl: this.findAddressApi(fetchResult.info.applet.features) }
                this.setState({ lookUpInputInfo }, () => {
                    this.lookupAddNewModal.modal.showModal()
                })
            })
        })
    }

    addLookUpdata = (info, data) => {
        if (data) {
            data.frame = info?.frame
            data.applet = info?.applet
            HttpServices.request(info.postUrl, data, (fetchResult, fetchError) => {
                if (fetchError) {
                    return
                }
                if (this.props.page._id == info.frame) {

                    let data = this.state.data
                    data.splice(0, 0, fetchResult.info)
                    this.setState({ data })
                }
                let forceInputUpdate = { ...this.state.forceInputUpdate }
                forceInputUpdate[info.headerKey] = true
                this.setState({ forceInputUpdate }, () => {
                    delete forceInputUpdate[info.headerKey]
                    this.setState({ forceInputUpdate })
                })
                this.lookupAddNewModal.modal.hideModal()
            })
        }
    }

    findAddressApi = (features) => {
        let feature = features[0]
        let info = ''
        if (['Database', 'inquiry'].includes(feature)) {
            info = 'postRecord'
        }
        else if (['Tasking'].includes(feature)) {
            info = 'addTask'
        }
        return info
    }
    setAddViewLoading = (prop) => {
        this.setState({ isLoadingView: prop })
    }

    changePagination = (index) => {
        this.setState({ currentPage: index }, () => {
            // let sortedBy = this.props.currentView?.settings?.sortedBy ? this.props.currentView?.settings?.sortedBy : {}
            // if (this.state.hasFilter) {
            // this.fetchData(this.state.filters, true)
            // } else {
            //     this.fetchData(null, true)
            // }
            // if (this.state.hasFilter) {
            //     this.fetchData(this.state.filters, false)
            // } else {
            this.fetchData(null, false)
            // }
        })
    }

    removeSelectedField = () => {
        this.setState({ selectedField: null })
    }

    duplicateElement = (record, records, recordss, recordsss) => {
        let newRecord = JSON.parse(JSON.stringify(record.values))
        newRecord = { values: newRecord }
        this.submitForm(newRecord)

        // let id = nanoid()
        // newRecord._id = id
        // let data = this.state.data
        // data = [...data, newRecord]
        // this.setState({ data })
        // let newParents = [...parents]
        // let target = {}

        // if (rowChildrenCount == 1) {
        //     newParents.pop()
        //     newParents[newParents.length - 1] = { id: nanoid(), type: 'row' }
        //     newParents.push({ id: nanoid(), type: 'column' })
        //     newElement.parents = newParents
        //     target = { id: newParents[newParents.length - 1]?.id, type: 'row', position: 'bottom' }
        // } else {
        //     target = { id: newParents[newParents.length - 1]?.id, type: 'column', position: 'bottom' }
        // }
        // let targetParents = [...newParents]
        // targetParents.pop()
        // target.parents = targetParents
        // this.doAddElement(null, newElement, newParents, target)
        // this.setState({ selectedSection: null })
    }



    openPermissions = () => {
        this.permissionsModal.open()
    }


    setCachedRelatedApplet = (info, cb) => {
        let cachedRelatedApplets = this.state.cachedRelatedApplets ?? {}
        cachedRelatedApplets[info?.applet?._id] = info

        this.setState({ cachedRelatedApplets }, () => {
            if (cb) {
                cb()
            }
        })
    }




    render() {
        // console.log('xxxxxxxxxxxxxxxxxx111', this.props.changeWindowLink);
        let headersItemModal = []
        let relevantHeadersItemModal = []
        if (this.props?.headers) {
            this.props?.headers.forEach(header => {
                if (header.col == null) {
                    header.col = 12
                }
                if (header.information) {
                    // header.information.disabled = false
                    // header.information.inplaceEditable = true
                }
                headersItemModal.push(header)
            })
        }
        if (this.state.relevantHeaders) {
            this.state.relevantHeaders.forEach(header => {
                if (header.col == null) {
                    header.col = 12
                }
                if (header.information) {
                    header.information.disabled = false
                    // header.information.inplaceEditable = true
                }
                relevantHeadersItemModal.push(header)
            })
        }
        let background = this.props.colors ? `linear-gradient(90deg, ${this.props.colors?.primaryColor}, ${this.props.colors?.secondaryColor})` : 'linear-gradient(to right, #5856D6, #7D7AFF)'
        let variables = { ...this.props.variables }

        variables.frameId = this.state.currentRelevantTab ?? this.props.page?._id
        variables.currentItem = this.state.relevantCurrentItem ?? this.state.currentItem

        let requiredPermission
        if (this.props.permissionLevel == 'applet') {
            requiredPermission = `applet`
        } else {
            requiredPermission = `frames.${this.state.page?._id}`
        }

        let newRecordText = 'New Record'
        if (this.props.page?.customAdd?.function == "openInviteUser") {
            newRecordText = 'Invitation'
        }

        let pagesCount = Math.ceil(this.state.totalCount / this.state.limit)

        // console.log(this.props.page)
        return (
            <div className='h-100  w-100  d-flex flex-column' style={{ position: 'relative' }}>
                {/* <div className="px-3 pt-1 pb-1 flexc" style={{ marginTop: -10, background: 'linear-gradient(to right, rgba(70, 133, 204, 1), rgba(70, 70, 204, 1))' }}>
                    <p className="text-smaller white">Form Name</p>
                    <div className="mx-2 flexcc" style={{backgroundColor:'#ffffff20',borderRadius:30,height:20,width:20}}>
                    <p className=" white">+</p>
                    </div>
                </div> */}

                <div className="w-100  position-relative d-flex flex-column flex-1 mt-2" style={{ minHeight: 0, display: (this.state.edit || this.state.relevantEdit || this.state.newInquiry || this.state.editInquiry || this.state.editActions) ? 'none' : '' }}>

                    {this.state.tabs && (
                        <div className="w-100 flexc px-2  " style={{ marginBottom: 2 }}>
                            <button className="mrd-1 px-3 py-1" style={{ backgroundColor: '#eee', borderRadius: '8px 8px 0px 0px' }}>
                                <p className="font-size-13 weight-500 ">{translate("All")}</p>
                            </button>

                            {this.state.tabs.map((tab, index) => {
                                return (
                                    <button className="mrd-1 px-3 py-1" style={{ backgroundColor: '#eee', borderRadius: '8px 8px 0px 0px', color: '#777' }}>
                                        <p className="font-size-13 weight-500 ">{tab.label}</p>
                                    </button>
                                )
                            })}
                        </div>
                    )}

                    {this.state.showTable == true && this.props.page && (
                        <div className="w-100 px-2 flex-1 pb-2" style={{ minHeight: 0 }}>
                            <ViewSwitcher
                                ref={el => this.viewSwitcher = el}
                                setCurrentHead={this.setCurrentHead} currentHead={this.state.currentHead}
                                openSelectStack={this.openSelectStack} applet={this.props.applet}
                                handleCopy={this.handleCopy} view={this.state.currentView}
                                page={this.props.page}
                                stackedKey={this.state.stackedKey ?? this.state.currentView?.settings?.stacked}
                                checkProps={this.state.checkProps} changeValue={this.changeValue}
                                tempValue={this.state.tempValue} clearTempValue={this.clearTempValue}
                                updateRecord={this.updateRecord}
                                userSettings={this.props.userSettings}
                                saveUserSettings={this.saveUserSettings}
                                headers={this.props.page?.fields ?? this.props.page?.fields}
                                data={this.state.data}
                                actions={this.state.actions}
                                width={this.props.width}
                                functionsHandler={this.functionsHandler}
                                submitForm={this.submitForm}
                                duplicateField={this.duplicateField}
                                permissions={this.props.permissions}
                                colors={this.props.colors}
                                params={this.state.params}
                                sortFieldRecord={this.sortFieldRecord} fieldOptions={this.fieldOptions} insertField={this.insertField} hideHeaderField={this.hideHeaderField} groupByField={this.groupByField} deleteHeaderField={this.deleteHeaderField} isLoadingData={this.state.isLoadingData} setData={this.setData} defaultStackedKey={this.state.currentView?.settings?.stacked} currentFrame={this.state.currentFrame} changeStackedKey={this.setStackedKey}
                                initData={this.state.currentItem} variables={this.state.variables ?? this.props.variables} changePage={this.changePagination} limit={this.state.limit} totalCount={this.state.totalCount} skip={this.state.skip} currentPage={this.state.currentPage} currentRecord={this.state.currentRecord} currentRecordStage={this.state.currentRecordStage} changeRecordStage={this.changeRecordStage} setCurrentRecordStage={this.setCurrentRecordStage} automations={this.props.automations} />

                        </div>
                    )}

                    <div className="w-100 px-2 py-2 window-content-radius-bottom flexc" style={{ backgroundColor: '#f4f4f4', boxShadow: '0 -10px 10px -10px rgba(0, 0, 0, 0.3);' }}>

                        <button title={translate("Refresh")} className="mrd-4 flexcc mld-1">
                            <img src="/assets/icons/useful/refresh.svg" height={12} alt="" />
                        </button>

                        {this.state.totalCount != null && (
                            <>

                                <div className="mrd-4">
                                    <p className="font-size-13 color-gray-1 weight-500">{translate("Total count")}: {this.state.totalCount}</p>
                                </div>

                                <div className="mrd-4 flexc">

                                    <button onClick={() => { if (this.state.currentPage > 0) this.changePagination(this.state.currentPage - 1) }} title={translate("Previous page")} className="mrd-1 flexcc mld-1 flexcc" style={{ cursor: this.state.currentPage == 0 ? 'not-allowed' : null, opacity: this.state.currentPage == 0 ? '0.2' : '1' }}>
                                        <img className="rotate-0" src="/assets/icons/useful/angle-small-left.svg" height={16} alt="" />
                                    </button>

                                    <p className="font-size-13 color-gray-1 weight-500">{translate("Page")} {this.state.currentPage + 1}</p>

                                    <button onClick={() => { if (this.state.currentPage < pagesCount - 1) this.changePagination(this.state.currentPage + 1) }} title={translate("Next page")} className="mld-1 flexcc mld-1 flexcc " style={{ cursor: this.state.currentPage == pagesCount - 1 ? 'not-allowed' : null, opacity: this.state.currentPage == pagesCount - 1 ? '0.2' : '1' }}>
                                        <img className="rotate-180" src="/assets/icons/useful/angle-small-left.svg" height={16} alt="" />
                                    </button>

                                </div>

                            </>
                        )}

                        {this.state.filters?.root?.conditions && Array.isArray(Object.values(this.state.filters?.root?.conditions)) && Object.values(this.state.filters?.root?.conditions)?.length > 0 && (

                            <button onClick={() => { this.openFilterView() }}>
                                <p className="font-size-13 color-gray-1 weight-500" style={{ color: '#007aff' }}>{translate("Data is Filtered")}</p>
                            </button>

                        )}
                    </div>


                    {(this.state.currentView?.type != 'form' && !this.props.userView && !this.state.currentView?.noAddNew && !this.props.page?.noAddNew) && (
                        <div className="flexc">
                            <div className={"new-record-but flexc"}>
                                {/* {(checkPermission(this.props.permissions, `${requiredPermission}.addNewRecord`) && this.props.appletAccess) && ( */}
                                {((checkPermission(this.props.permissions, `${requiredPermission}.create`)) || this.props.page?.ignorePermission) && (
                                    <ButtonAnimated
                                        iconwidth='24px'
                                        onClick={this.addClicked}
                                        title={translate(newRecordText)}
                                        icon='/assets/icons/plus-white.svg'
                                        textColor={this.props.colors?.textColor}
                                        invert={this.props.colors?.iconInvert}
                                        bg={background}
                                    />
                                )}
                                {/* <button onClick={() => this.addClicked()} className='px-1 py-1  flexcb ' style={{ background: " linear-gradient(to right, rgba(70, 133, 204, 0.9), rgba(70, 70, 204, 0.9))", borderRadius: 8, color: '#fff', transition: 'all 0.5s', boxShadow: '0px 0px 10px #10101030' }}>
                                 <p className='text-small text-semibold mld-3 mrd-3 ' style={{ whiteSpace: 'nowrap' }}>{translate("New Record")}</p>
                                 <div className='flexcc mld-3 p-1' style={{ background: 'linear-gradient(to right, #ffffff10, #ffffff20)', borderRadius: 8 }}>
                                     <img className='invert' src='/assets/icons/plus.svg' height={18} />
                                 </div>
                             </button> */}
                            </div>
                        </div>
                    )}
                </div>
                <StackedField setData={this.setData} setViews={this.setViewSettings} defaultStackedKey={this.state.currentView?.settings?.stacked} currentFrame={this.state.currentFrame} view={this.state.currentView} headers={this.props.page?.fields} ref={el => this.StackedField = el} width={this.props.width} changeValue={this.setStackedKey} colors={this.props.colors} page={this.props.page} />

                <SidebarView updatePos width={this.props.width + 200} onClosed={this.removeSelectedField} widthImport={350} ref={e => this.fieldsData = e}>
                    <EditFields editField={this.editField} setIsLoadingAddField={this.setIsLoadingAddField} setData={this.setData} selectedField={this.state.selectedField} addField={this.updateField} deleteHeader={this.state.deleteHeader} page={this.props.page} width={this.props.width} initData={this.state.selectedField?.information} field={JSON.parse(JSON.stringify(FormBuilderObjects[this.state.selectedField?.type] ?? {}))} colors={this.props.colors} closeFieldsData={this.closeFieldsData} params={this.props.page?.fields} fields={this.props.page?.fields} />
                </SidebarView>

                <SidebarView width={this.props.width} zIndex={40} ref={el => this.addField = el} widthCondition={{ xs: "80%", sm: "50%", md: '45%', lg: "35%", xl: "25%" }}>
                    <AddFieldsList setCurrentHead={this.setCurrentHead} currentHead={this.state.currentHead} setData={this.setData} addField={this.addFieldInput} hideAddCustomField={this.hideAddCustomField} currentFrame={this.state.currentFrame} colors={this.props.colors} page={this.props.page} applet={this.props.applet} setIsLoadingAddField={this.setIsLoadingAddField} isLoadingAddField={this.state.isLoadingAddField} params={this.props.params} variables={this.props.variables} />
                </SidebarView>

                <SidebarView width={this.props.width} zIndex={40} ref={el => this.showActivityLogs = el} widthCondition={{ xs: "60%", sm: "50%", md: '35%', lg: "35%", xl: "25%" }}>
                    <ActivityLogs setData={this.setData} recordLogs={this.state.recordLogs} currentFrame={this.state.currentFrame} headers={this.props.page?.fields} />
                </SidebarView>

                <SidebarView width={this.props.width} zIndex={'999'} ref={e => this.selectPathSidebar = e}>
                    <div>
                        {this.state.selectPath?.map((element, index) => {
                            return (
                                <button onClick={() => this.choosePath(element, this.state.allDecisions)} className="hover-gray ptd-2 w-100 " style={{ cursor: 'pointer', display: 'block' }}>
                                    <p className="mb-0 text-semibold">path {index + 1}</p>
                                </button>
                            )
                        })}
                    </div>
                </SidebarView>

                <SidebarView width={this.props.width} zIndex={'999'} ref={e => this.selectDecisionSidebar = e}>
                    <div>
                        {/* {Object.values(this.state.allDecisions)?.map((element, index) => {
                            return (
                                <button onClick={() => this.choosePath(element, this.state.allDecisions)} className="hover-gray ptd-2 w-100 " style={{ cursor: 'pointer', display: 'block' }}>
                                    <p className="mb-0 text-semibold">path {index + 1}</p>
                                </button>
                            )
                        })} */}
                    </div>
                </SidebarView>
                {/* {this.state.edit && (
                    <ItemModal
                        ref={el => this.itemModal = el}
                        page={this.props.page}
                        headers={this.state.relevantEdit ? relevantHeadersItemModal : (headersItemModal ?? this.state?.headers)}
                        pages={this.props.page?.formPages}
                        onClose={this.itemModalClosed}
                        initData={this.state.relevantEdit ? this.state.relevantCurrentItem : this.state.currentItem}
                        variables={this.props.variables ?? variables}
                        forceInputUpdate={this.state.forceInputUpdate}
                        permissions={this.props.permissions}
                        // itemAdded={this.itemAdded}
                        // itemEdited={this.itemEdited}
                        width={this.props.width}
                        // showDates={true}
                        submitForm={this.state.relevantEdit ? this.submitRelevantForm : this.submitForm}
                        // functionsHandler={this.functionsHandler}
                        // widthImport={300}

                        functionsHandler={this.functionsHandler}
                        background={background}
                        isMobile={this.props.isMobile}
                        colors={this.props.colors}
                        edit={this.state.edit}
                        setData={this.setData}
                    />
                )} */}


                {/* {console.log("this.state.overlayFrames",this.state.overlayFrames)} */}

                {this.state.overlayFrames && this.state.overlayFrames.map((overlayFrame) => {
                    // console.log("overlayFrame", overlayFrame)
                    if (overlayFrame.type == 'record') {
                        return (
                            <RecordViewerModal
                                ref={el => this.RecordViewerModal = el}
                                updateUserSettings={this.props.updateUserSettings}
                                appletAccess={this.props.appletAccess}
                                mainFunctionsHandler={this.props.functionsHandler}
                                lastStagePage={this.props.lastStagePage}
                                mainVariables={this.props.variables}
                                goToHub={this.props.goToHub}
                                changeStage={this.props.changeStage}
                                language={this.props.language}
                                mainHeaders={this.props.page?.fields}
                                automations={this.props.automations}
                                modules={this.props.modules}
                                height={this.props.height}
                                setHeader={this.props.setHeader}
                                setMainData={this.props.setData}
                                updateFrameInfo={this.props.updateFrameInfo}
                                changePage={this.props.changePage}
                                changeWindow={this.props.changeWindow}
                                permissions={this.props.permissions}
                                permissionLevel={this.props.permissionLevel}
                                frame={this.props.page}
                                headers={headersItemModal ?? this.state?.headers}
                                // pages={this.props.page?.formPages}
                                onClose={this.itemModalClosed}
                                initData={JSON.parse(JSON.stringify(this.state.currentItem ?? {}))}
                                variables={this.state.variables ?? variables}
                                itemAdded={this.itemAdded}
                                itemEdited={this.itemEdited}
                                width={this.props.width}
                                // showDates={true}
                                submitForm={this.submitForm}
                                background={background}
                                isMobile={this.props.isMobile}
                                colors={this.props.colors}
                                // data={this.state.data}
                                // relevantData={this.state.relevantData}
                                // relevants={this.state.relevants}
                                // relevantAddClicked={this.relevantAddClicked}
                                windowData={this.props.windowData}
                                changeWindowLink={this.props.changeWindowLink}
                                setData={this.setData}
                                fetchRelevantData={this.fetchRelevantData}
                                fieldOptions={this.fieldOptions}
                                tempValue={this.state.tempValue}
                                updateRecord={this.updateRecord}
                                clearTempValue={this.clearTempValue}
                                applet={this.props.applet}
                                // actionsBtn={this.state.relevantActions}
                                functionsHandler={this.functionsHandler}
                                changeValue={this.changeValue}
                                saveUserSettings={this.saveUserSettings}
                                userSettings={this.props.userSettings}
                                stackedKey={this.state.stackedKey ?? this.state.currentView?.settings?.stacked}
                                view={this.state.currentView}
                                setCurrentHead={this.setCurrentHead}
                                currentHead={this.state.currentHead}
                                deleteHeaderField={this.deleteHeaderField}
                                // relevantEdit={this.state.relevantEdit}
                                isLoadingData={this.state.isLoadingData}
                                baseUrl={this.props.baseUrl}
                                frameActions={this.state.actions}
                                cachedRelatedApplets={this.state.cachedRelatedApplets}
                                setCachedRelatedApplet={this.setCachedRelatedApplet}
                                connections={this.props.connections}
                                params={overlayFrame.params}
                            />
                        )
                    }

                    if (overlayFrame.type == 'page') {
                        return (
                            <PageViewerInstant path={overlayFrame.path} params={overlayFrame.params} overlayInfo={overlayFrame} width={this.props.width} baseUrl={this.props.baseUrl} functionsHandler={this.functionsHandler} colors={this.props.colors} height={this.props.height} changeWindowLink={this.props.changeWindowLink} pageChangePage={this.props.pageChangePage} applet={this.props.applet} addNewWindow={this.props.addNewWindow} variables={this.props.variables} />
                        )
                    }
                })}
                {/* <div className="w-100 h-100" style={{ display: this.state.newInquiry ? 'flex' : 'none' }}> */}
                {/* <NewInquiry stageName={'newInquery'} permissions={this.props.permissions} ref={el => this.NewInquiry = el} newInquiry={this.state.newInquiry} setData={this.setData} setHeader={this.props.setHeader} colors={this.props.colors} width={this.props.width} height={this.props.height} formPages={this.props.page?.formPages} changePage={this.props.changePage} addNotif={this.props.addNotif} page={this.props.page} baseUrl={[...this.props.baseUrl]} windowData={this.props.windowData} applet={this.props.applet} headers={this.props.page?.fields} automations={this.props.automations} language={this.props.language} userSettings={this.props.userSettings} lastStagePage={this.props.lastStagePage} changeWindowLink={this.props.changeWindowLink} changeStage={this.props.changeStage} goToHub={this.props.goToHub} variables={this.props.variables} defaultCollectionHeader={this.defaultCollectionHeader} /> */}
                {/* </div> */}
                {/* {this.state.editInquiry &&
                    <SingleRecordView participation={this.state.currentView?.noAddNew} defaultCollectionHeader={this.defaultCollectionHeader} permissions={this.props.permissions} ref={el => this.singleRecord = el} currentItem={this.state.currentItem} editInquiry={this.state.editInquiry} setData={this.setData} setHeader={this.props.setHeader} colors={this.props.colors} width={this.props.width} height={this.props.height} formPages={this.props.page?.formPages} changePage={this.props.changePage} addNotif={this.props.addNotif} page={this.props.page} baseUrl={[...this.props.baseUrl]} windowData={this.props.windowData} applet={this.props.applet} headers={this.props.page?.fields} automations={this.props.automations} language={this.props.language} userSettings={this.props.userSettings} lastStagePage={this.props.lastStagePage} changeWindowLink={this.props.changeWindowLink} changeStage={this.props.changeStage} goToHub={this.props.goToHub} variables={this.props.variables} />
                } */}
                {/* {this.state.editActions &&
                    <div className="w-100 h-100">
                        <ViewSwitcher ref={el => this.viewSwitcher = el} setCurrentHead={this.setCurrentHead} currentHead={this.state.currentHead} openSelectStack={this.openSelectStack} applet={this.props.applet} view={this.state.currentView} page={this.props.page} stackedKey={this.state.stackedKey ?? this.state.currentView?.settings?.stacked} checkProps={this.state.checkProps} changeValue={this.changeValue} tempValue={this.state.tempValue} clearTempValue={this.clearTempValue} updateRecord={this.updateRecord} userSettings={this.props.userSettings} saveUserSettings={this.saveUserSettings} headers={this.state.actionHeaders} data={this.props.page?.actions} actions={this.state.actions} width={this.props.width} functionsHandler={this.functionsHandler} submitForm={this.submitForm} fieldOptions={this.fieldOptions} hideHeaderField={this.hideHeaderField} deleteHeaderField={this.deleteHeaderField} isLoadingData={this.state.isLoadingData} setData={this.setData} defaultStackedKey={this.state.currentView?.settings?.stacked} currentFrame={this.state.currentFrame} changeStackedKey={this.setStackedKey} colors={this.props.colors} initData={this.state.currentItem} variables={this.state.variables ?? this.props.variables} changePage={this.changePagination} limit={this.state.limit} totalCount={this.state.totalCount} skip={this.state.skip} currentPage={this.state.currentPage} currentRecord={this.state.currentRecord} />
                        <div className={"position-absolute"} style={{ bottom: '10px', right: 10 }}>
                            {(checkPermission(this.props.permissions, `${requiredPermission}.addNewRecord`) && this.props.appletAccess) && (
                                <ButtonAnimated
                                    iconwidth='24px'
                                    onClick={this.addAction}
                                    title={translate('New Action')}
                                    icon='/assets/icons/plus-white.svg'
                                    textColor={this.props.colors?.textColor}
                                    invert={this.props.colors?.iconInvert}
                                    bg={background}
                                />
                            )}
                           
                        </div>
                    </div>
                } */}
                {/* {this.state.extraItems && this.state.extraItems.map((prop, index) => {
                    return (
                        <ItemModal
                            ref={el => this["itemModal" + index] = el}
                            page={prop.page}
                            headers={prop.page?.headers}
                            initData={prop.data}
                            variables={this.props.variables}
                            itemAdded={this.itemAdded}
                            itemEdited={this.itemEdited}
                            openRefModal={this.openRefModal}
                            functionsHandler={this.functionsHandler}
                            showDates={true}
                            modalIndex={index}
                            />
                            )
                            
                        })} */}

                {/* <SidebarView ref={e => this.stageSide = e} width={this.props.width} widthCondition={{ xs: "50%", sm: "40%", md: '30%', lg: "30%", xl: "20%" }} >
                    <div className="px-2 py-3">
                        {this.state.currentRecord && this.state.currentRecord['**stage'] ?
                            (this.state.currentRecord['**stage']?.information?.workflow?.stages?.map((element, index) => {
                                return (
                                    <div className="px-2 br-6 px-2 py-2 mb-3" style={{ display: index < this.state.currentRecordStageIndex ? 'none' : '', background: this.state.currentRecordStage == element.id ? (this.props.colors?.background ?? '#4c05a8') : '#eee', cursor: 'pointer' }} onClick={() => this.changeRecordStage(element)}>
                                        <button>
                                            <p style={{ color: this.state.currentRecordStage == element.id ? (this.props.colors?.textColor ?? '#fff') : '#222' }}>{checkTranslation(element.name)}</p>
                                        </button>
                                    </div>
                                )
                            })) : (
                                <div>
                                    <p>{translate("There are no stages to show")}</p>
                                </div>
                            )}
                    </div>
                </SidebarView> */}

                <SidebarView ref={e => this.subTaskSide = e} width={this.props.width} widthCondition={{ xs: "100%", sm: "70%", md: '60%', lg: "50%", xl: "40%" }} >
                    <div className="w-100 h-100 px-3 py-2">
                        <FormViewer variables={this.props.variables} width={100} ref={el => this.subTaskForm = el} headers={this.props.page?.fields} initData={this.state.taskData} formClass="modern" inputClass={'modern-input'} />
                        <ButtonAnimated
                            iconwidth='24px'
                            onClick={this.submitTask}
                            title='submit'
                            icon='/assets/icons/plus-white.svg'
                            textColor={this.props.colors?.textColor}
                            invert={this.props.colors?.iconInvert}
                            bg={background}
                        />
                    </div>
                </SidebarView>

                <FilterEditorModal headers={this.props.page?.fields} ref={el => this.FilterEditorModal = el} width={this.props.width} colors={this.props.colors} background={background} functionsHandler={this.functionsHandler} setData={this.setData} data={this.state.filters} isLoading={this.state.isLoadingData} changeValue={this.changeValue} setHeader={this.props.setHeader} />
                <PrintLabelModal headers={this.props.page?.fields} variables={this.props.variables} ref={el => this.PrintLabelModal = el} width={this.props.width} colors={this.props.colors} background={background} functionsHandler={this.functionsHandler} setData={this.setData} data={this.state.filters} isLoading={this.state.isLoadingData} changeValue={this.changeValue} setHeader={this.props.setHeader} />

                <SidebarView ref={e => this.groupBySide = e} width={this.props.width} widthCondition={{ xs: "70%", sm: "50%", md: '40%', lg: "30%", xl: "20%" }}>
                    <GroupedBy data={this.state.currentView?.settings?.groupBy} setData={this.setData} headers={this.props.page?.fields} width={this.props.width} colors={this.props.colors} />
                </SidebarView>

                <SidebarView ref={e => this.sortBySide = e} width={this.props.width} widthCondition={{ xs: "70%", sm: "50%", md: '40%', lg: "30%", xl: "20%" }}>
                    <SortedBy setData={this.setData} headers={this.props.page?.fields} width={this.props.width} colors={this.props.colors} background={background} functionsHandler={this.functionsHandler} hasSortedBy={this.state.hasSortedBy} />
                </SidebarView>

                <SidebarView ref={e => this.customizeCardSide = e} width={this.props.width} widthCondition={{ xs: "70%", sm: "50%", md: '40%', lg: "30%", xl: "20%" }}>
                    <CustomizeCard setData={this.setData} headers={this.props.page?.fields} width={this.props.width} currentFrame={this.props.page} view={this.state.currentView} colors={this.props.colors} background={background} addNotif={this.props.actions.addNotif} setViewSettings={this.setViewSettings} closeSide={this.closeSide} />
                </SidebarView>

                <SidebarView ref={e => this.customizeFieldsSide = e} width={this.props.width} widthCondition={{ xs: "85%", sm: "60%", md: '50%', lg: "40%", xl: "30%" }}>
                    <CustomizeFields setViews={this.setViews} setData={this.setData} headers={this.props.page?.fields} width={this.props.width} page={this.props.page} view={this.state.currentView} addNotif={this.props.actions.addNotif} setViewSettings={this.setViewSettings} closeSide={this.closeSide} setFields={this.setFields} colors={this.props.colors} />
                </SidebarView>

                <SidebarView ref={e => this.relatedFramesSide = e} width={this.props.width} widthCondition={{ xs: "85%", sm: "60%", md: '50%', lg: "40%", xl: "30%" }}>
                    <RelatedFrames setViews={this.setViews} setData={this.setData} headers={this.props.page?.fields} width={this.props.width} page={this.props.page} view={this.state.currentView} addNotif={this.props.actions.addNotif} setViewSettings={this.setViewSettings} closeSide={this.closeSide} setFields={this.setFields} colors={this.props.colors} />
                </SidebarView>

                <SidebarView ref={e => this.synchronizationsSide = e} width={this.props.width} widthCondition={{ xs: "85%", sm: "60%", md: '50%', lg: "40%", xl: "30%" }}>
                    <FrameSynchronizations setViews={this.setViews} setData={this.setData} headers={this.props.page?.fields} width={this.props.width} page={this.props.page} view={this.state.currentView} addNotif={this.props.actions.addNotif} setViewSettings={this.setViewSettings} closeSide={this.closeSide} setFields={this.setFields} colors={this.props.colors} variables={this.props.variables} />
                </SidebarView>


                <SidebarView width={this.props.width} zIndex={40} ref={el => this.addView = el} isDesktop={this.props.isDesktop} isMobile={this.props.isMobile} widthCondition={{ xs: "70%", sm: "50%", md: '35%', lg: "35%", xl: "25%" }}>
                    <AddViewList functionsHandler={this.functionsHandler} setAddViewLoading={this.setAddViewLoading} isLoadingView={this.state.isLoadingView} background={background} currentFrame={this.state.currentFrame} closeAddView={this.closeAddView} frame={this.props.page} setData={this.props.setData} hideAddView={this.hideAddView} headers={this.props.page?.fields} />
                </SidebarView>

                <SidebarView width={this.props.width} zIndex={40} ref={el => this.addRelevantCollection = el} isDesktop={this.props.isDesktop} isMobile={this.props.isMobile} widthCondition={{ xs: "70%", sm: "50%", md: '35%', lg: "35%", xl: "25%" }}>
                    <AddViewList functionsHandler={this.functionsHandler} setAddViewLoading={this.setAddViewLoading} isLoadingView={this.state.isLoadingView} background={background} currentFrame={this.state.currentFrame} closeAddView={this.closeAddView} frame={this.props.page} setData={this.props.setData} hideAddView={this.hideAddView} headers={this.props.page?.fields} />
                </SidebarView>

                <SidebarView width={this.props.width} zIndex={40} ref={el => this.historyViewer = el} isDesktop={this.props.isDesktop} isMobile={this.props.isMobile} widthCondition={{ xs: "70%", sm: "50%", md: '35%', lg: "35%", xl: "25%" }}>
                    <HistoryViewer functionsHandler={this.functionsHandler} currentItem={this.state.currentItem} setAddViewLoading={this.setAddViewLoading} isLoadingView={this.state.isLoadingView} background={background} currentFrame={this.state.currentFrame} variables={this.state.variables ?? variables} closeAddView={this.closeAddView} frame={this.props.page} setData={this.props.setData} hideAddView={this.hideAddView} headers={this.props.page?.fields} colors={this.props.colors} />
                </SidebarView>

                <RemoveConfirmationModal
                    isLoading={this.state.isLoadingRemove}
                    confirmed={this.state.relevantEdit ? this.fetchRelevantRemove : this.fetchRemove}
                    ref={el => this.removeModal = el}
                />

                <RemoveHeaderModal
                    isLoading={this.state.isLoadingRemove}
                    confirmed={this.fetchHeaderRemove}
                    selectedField={this.state.selectedField}
                    ref={el => this.removeHeaderModal = el}
                    setData={this.setData}
                />
                <LookupAddNewModal
                    isLoading={this.state.isLoadingView}
                    isLoadingFetch={this.state.isLoadingFetch}
                    submit={this.addLookUpdata}
                    lookUpInputInfo={this.state.lookUpInputInfo}
                    ref={el => this.lookupAddNewModal = el}
                    colors={this.props.colors}
                />
                <HideHeaderModal
                    isLoading={this.state.isLoadingRemove}
                    confirmed={this.fetchHeaderHide}
                    selectedField={this.state.selectedField}
                    ref={el => this.hideHeaderModal = el}
                    colors={this.props.colors}
                />

                <AddUserModal
                    itemAdded={this.itemAdded}
                    itemEdited={this.itemEdited}
                    ref={el => this.addUserModal = el}
                    variables={this.props.variables}
                    page={this.props.page}
                    headers={this.props.page?.headers ?? this.props.page?.fields}
                    initData={this.state.currentItem}
                    colors={this.props.colors}
                />

                <AddUserSidebar
                    itemAdded={this.itemAdded}
                    itemEdited={this.itemEdited}
                    ref={el => this.addUserSidebar = el}
                    variables={this.props.variables}
                    page={this.props.page}
                    headers={this.props.page?.headers ?? this.props.page?.fields}
                    initData={this.state.currentItem}
                    colors={this.props.colors}
                />

                <PrintModal setData={this.setData} width={this.props.width} closeModal={() => this.PrintModal.modal.hideModal()} ref={el => this.PrintModal = el} data={this.state?.course} />
                <ImportModal setData={this.setData} width={this.props.width} closeModal={() => this.ImportModal.modal.hideModal()} ref={el => this.ImportModal = el} data={this.state?.course} page={this.props.page} headers={this.props.page?.fields} colors={this.props.colors} />
                <ExportModal setData={this.setData} width={this.props.width} closeModal={() => this.ExportModal.modal.hideModal()} ref={el => this.ExportModal = el} frame={this.props.page} data={this.state?.course} headers={this.props.page?.fields} currentPage={this.state.currentPage} filter={this.state.filters} />
                {/* filterForData={this.state.filterForData}  */}
                <MemoModal ref={el => this.memoModal = el} variables={variables} page={this.props.page} frames={[this.props.page]} width={this.props.width} colors={this.props.colors} updateStage={this.updateStage} />

                <FramePermissionsModal ref={el => this.permissionsModal = el} variables={variables} page={this.props.page} frames={[this.props.page]} width={this.props.width} colors={this.props.colors} actions={this.props.actions} />
                <ActionsConfigModal ref={el => this.actionsConfigModal = el} variables={variables} initData={this.props.page?.actions} width={this.props.width} colors={this.props.colors} params={this.props.page?.fields} fields={this.props.page?.fields} page={this.props.page} functionsHandler={this.functionsHandler} setData={this.setData} applet={this.props.applet} />

                <FrameAutomationsModal ref={el => this.frameAutomationsModal = el} variables={variables} functionsHandler={this.functionsHandler} frame={this.props.page} initData={this.props.page?.actions} width={this.props.width} colors={this.props.colors} params={this.props.page?.fields} />

            </div>
        )
    }

    submitForm = (rawData, refresh, cb) => {
        // console.log("submitForm")
        let data
        let referenceKey = this.props.page.referenceKey
        // console.log('tp1');
        if (!rawData) {
            // console.log('tp2');
            if (referenceKey) {
                // console.log('tp3');
                data = { [referenceKey]: this.form.getForm() }
            } else {
                // console.log('tp4');
                data = this.form.getForm()
            }
        } else {
            // console.log('tp5');
            if (referenceKey) {
                // console.log('tp6');
                data = { [referenceKey]: rawData }
            } else {
                // console.log('tp7');
                data = rawData
            }
        }
        if (data) {
            let page = this.props.page

            // console.log('addddddddddddd',page)

            let isEditing = data._id ? true : false
            let address = isEditing ? (page.editUrl ?? page.addUrl) : page.addUrl
            this.setState({ isPostingData: true })
            if (page.postBody) {
                data = { ...data, ...page.postBody }
            }
            for (const [key, value] of Object.entries(data)) {
                if (/\{\{(.*?)\}\}/.test(value)) {
                    if (this.props.variables) {
                        data[key] = this.props.variables[value.replace(/{/g, '').replace(/}/g, '')]
                    }
                }
            }
            data.frame = this.props.page?._id
            data.features = this.props.applet?.features

            // console.log("data", data)

            HttpServices.request(address, data, (fetchResult, fetchError, fetchStatus) => {
                this.setState({ isPostingData: false })

                // console.log(fetchResult, fetchError)
                if (fetchError) {
                    this.setState({ errors: fetchError.errors })
                    this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.postDataFailed', description: fetchError.message })
                    if (cb) {
                        cb(null, true)
                    }
                    return
                }

                if (cb) {
                    cb()
                }
                // this.modal.hideModal()
                this.props.actions.addNotif({ type: 'success', title: '{{lang}}info.postDataSuccesfully', description: '{{lang}}info.dataUpdatedSuccessfully' })
                if (!refresh) {
                    // TO DO
                    // this.setState({ checkProps: !this.state.checkProps })
                }
                if (!isEditing) {
                    // if (fetchResult.info) {
                    //     this.setState({ relevantHeaders: [] })
                    // }
                    this.itemAdded(fetchResult.info)
                }
                if (isEditing) {

                    if (fetchResult.info) {
                        this.itemEdited(fetchResult.info, data._id)
                    } else {
                        this.itemEdited(data, data._id)
                    }
                }
                // if (this.form) {
                //     this.form.clearForm()
                // }

                // if (this.itemModal) {
                //     this.itemModal.hideModal()
                // }
                // if (this.RecordViewerModal) {
                //     this.RecordViewerModal.hideModal()
                // }
            })
        }
    }

    // submitRelevantForm = (rawData, refresh, cb) => {
    //     let relevantData
    //     if (!rawData) {
    //         relevantData = this.form.getForm()
    //     } else {
    //         relevantData = rawData
    //     }
    //     if (relevantData) {
    //         let page = this.props.page
    //         let isEditing = relevantData._id ? true : false
    //         let address = isEditing ? (page.editUrl ?? page.addUrl) : page.addUrl
    //         this.setState({ isPostingData: true })
    //         if (page.postBody) {
    //             relevantData = { ...relevantData, ...page.postBody }
    //         }
    //         for (const [key, value] of Object.entries(relevantData)) {
    //             if (/\{\{(.*?)\}\}/.test(value)) {
    //                 if (this.props.variables) {
    //                     relevantData[key] = this.props.variables[value.replace(/{/g, '').replace(/}/g, '')]
    //                 }
    //             }
    //         }
    //         relevantData.features = this.props.applet?.features
    //         let search = window.location.search
    //         let relevantId = new URLSearchParams(search).get('relevant')
    //         relevantId = relevantId.split('/')[0]
    //         relevantData.frame = relevantId
    //         relevantData.relevant = true
    //         HttpServices.request(address, relevantData, (fetchResult, fetchError, fetchStatus) => {
    //             this.setState({ isPostingData: false })
    //             if (cb) {
    //                 cb()
    //             }
    //             if (fetchError) {
    //                 this.setState({ errors: fetchError.errors })
    //                 this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.postDataFailed', description: fetchError.message })
    //                 return
    //             }
    //             this.props.actions.addNotif({ type: 'success', title: '{{lang}}info.postDataSuccesfully', description: '{{lang}}info.dataUpdatedSuccessfully' })
    //             if (!refresh) {
    //             }
    //             if (!isEditing) {
    //                 if (fetchResult.info) {
    //                     this.setState({ relevantHeaders: [] })
    //                 }
    //                 this.relevantItemAdded(fetchResult.info)
    //             }
    //             if (isEditing) {
    //                 if (fetchResult.info) {
    //                     this.relevantItemEdited(fetchResult.info, relevantData._id)
    //                 } else {
    //                     this.relevantItemEdited(relevantData, relevantData._id)
    //                 }
    //             }
    //             if (this.itemModal) {
    //                 this.itemModal.hideModal()
    //             }
    //             if (this.RecordViewerModal) {
    //                 this.RecordViewerModal.hideModal()
    //             }
    //         })
    //     }
    // }
}


const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps,
    null,
    { forwardRef: true }
)(CollectionView);